const DEBUG = true;

let ProductPage = (() => {
  /*
    ========================================
    Product View
    ========================================
  */
  /*
    ==========
    - Init
    ==========
  */
  async function Init(url = "") {
    // Non request required init
    DescriptionBox.Init();
    VariantManager.InitVariantSelectors();

    return new Promise((resolve, reject) => {
      RequestProductData(url).then(product => {
        console.log(product);

        // Media
        let tags = product.tags;

        // Variants
        let variants = [];

        console.log(product.variants);

        product.variants.forEach(variant => {
          let newVariant = variant;

          if (newVariant.featured_image && newVariant.featured_image.src) {
            newVariant.featured_image = newVariant.featured_image.src;
          } else if (!newVariant.featured_image) {
            if (product.featured_image && product.featured_image.src) {
              newVariant.featured_image = product.featured_image.src;
            } else {
              newVariant.featured_image = product.featured_image;
            }
          }

          variants.push(newVariant);
        });


        let availableVariants = variants.filter(variant => variant.available);
        let firstAvailableVariant = availableVariants[0];
        if (!firstAvailableVariant) firstAvailableVariant = variants[0];

        // Product Specific
        GalleryManager.InitGallery(product.images);
        GiftWithPurchase.Init();

        // Variant Specific
        BadgeManager.InitBadges(firstAvailableVariant, tags);
        WishlistManager.SetWishlistCount(product);

        // convert price to avoid too many decimal points (happens in asia currencies)
        let defaultPrice = document.querySelector(".product-main-content .prices .price");
        let defaultComparePrice = document.querySelector(".product-main-content .prices .compare-price");

        if (defaultPrice) {
          let size = defaultPrice.getAttribute("data-price").replace(document.body.getAttribute("data-currency-symbol"), "").replace(",", "").replace(".", "").length;

          if (size < firstAvailableVariant.price.toString().length) {
            firstAvailableVariant.price = firstAvailableVariant.price.toString().slice(0, size);
          }
        }

        if (defaultComparePrice && defaultComparePrice.getAttribute("data-price") !== "") {
          let size = defaultComparePrice.getAttribute("data-price").replace(document.body.getAttribute("data-currency-symbol"), "").replace(",", "").replace(".", "").length;

          if (size < firstAvailableVariant.compare_at_price.toString().length) {
            firstAvailableVariant.compare_at_price = firstAvailableVariant.compare_at_price.toString().slice(0, size);
          }
        }

        VariantManager.SetActiveVariant(firstAvailableVariant);

        resolve(Object.freeze({
          GalleryManager,
          CTAManager,
        }));
      });
    });
  }

  /*
    ==========
    - Requests
    ==========
  */
  function RequestProductData(url = "") {
    return new Promise((resolve, reject) => {
      if (url === "") {
        resolve(undefined);
      }

      fetch(`${url.split("?")[0]}.js`).then(res => res.json()).then(res => {
        resolve(res);
      });
    });
  }

  /*
    ========================================
    Utility Objects
    ========================================
  */
  /*
      Checks Daylight Savings
  */
  function isDST(d) {
    let jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
    let jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();
    return Math.max(jan, jul) !== d.getTimezoneOffset();
  }

  /*
      Checks leap year
  */
  function leapYear(year) {
    return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
  }

  /*
    ====================
    Badge Manager
    ====================
  */
  const BadgeManager = (() => {
    /*
      Elements
    */
    let soldoutBadge = document.querySelector(".product-details__badge--sold-out");
    let comingSoonBadge = document.querySelector(".product-details__badge--coming-soon");
    let bogoBadge = document.querySelector(".product-details__badge--bogo");
    let lowStockBadge = document.querySelector(".product-details__badge--low-stock");
    let percentBadge = document.querySelector(".product-details__badge--percent-off");
    let saleBadge = document.querySelector(".product-details__badge--on-sale");
    let badgeParent = document.querySelector(".product-details__badge-container");
    let productTitle = document.querySelector(".product-details__primary-info h1");
    let customBadgeList = document.querySelector(".sk-custom-badge-list");

    /*
      Parameters
    */
    let badgeLimit = 3;
    let quantityLimit = 3;
    let isTimeProduct = false;
    let isNotSale = false;
    let isNoPercentOff = false;

    /*
      Cached
    */
    let cachedTags = [];

    /*
      Creation Functions
    */
    function CreateBadge(text = "", colour = "") {
      let badge = document.createElement("span");

      badge.classList.add("product-details__badge");
      // badge.classList.add(`product-details__badge--${text.replaceAll(" ", "-")}`);

      badge.innerText = text;

      if (colour !== "") {
        badge.style.color = colour;
      }

      return badge;
    }

    function InitBadges(variant = {}, tags = []) {
      // Get time product state
      isTimeProduct = document.querySelector(".product-main-content").getAttribute("data-is-time") === "true" ? true : false;

      cachedTags = tags;

      ResetBadges();
      PopulateBadges();

      RefreshBadgeState(variant);
    }

    function PopulateBadges() {
      let badgeCount = 0;

      // Custom metafield badges
      if (customBadgeList.childElementCount > 0) {
        // Copy all nodes to badge parent and put in front
        customBadgeList.childNodes.forEach(node => {
          let nodeCopy = node.cloneNode(true);
          badgeParent.insertBefore(nodeCopy, badgeParent.childNodes[0]);
          badgeCount++;
        });
      }

      // Tagged based badges
      let tagsLower = cachedTags.map(tag => tag.toLowerCase());

      // Has Custom Badge?
      let hasCustomBadge = tagsLower.find(tag => tag.includes("badge:"));

      // Has custom badge colour?
      let hasCustomBadgeColour = tagsLower.find(tag => tag.includes("badgecolour:"));
      let customBadgeColour = "";

      // Has custom badge time?
      let hasCustomBadgeTime = tagsLower.find(tag => tag.includes("badgetime:"));
      let customBadgeTime = "";
      let customBadgeTimeEnd = "";
      let customBadgeTimeActive = false;
      let customBadgeTimeStart = false;

      // Bundle?
      let isBundle = tagsLower.find(tag => tag.includes("bundle:"));
      let bundleBadgeMessage = "";

      if (isBundle) {
        bundleBadgeMessage = cachedTags.filter(tag => tag.toLowerCase().includes("bundle:"));
        bundleBadgeMessage = bundleBadgeMessage[0].split(":")[1];

        if (bundleBadgeMessage.toLowerCase() === "bundle a") {
          bundleBadgeMessage = "BUY 3 SOCKS SAVE 25%";
        }
      }

      if (hasCustomBadge || isBundle) {
        // Get badge list
        let badgesToCreate = [];

        if (isBundle) {
          badgesToCreate.push(bundleBadgeMessage);
        }

        if (hasCustomBadge) {
          cachedTags.forEach(tag => {
            if (tag.toLowerCase().includes("badge:")) {
              badgesToCreate.push(tag.split(":")[1]);
            }
          });
        }

        // Custom Colour
        if (hasCustomBadgeColour) {
          // Get target colour
          cachedTags.forEach(tag => {
            if (tag.toLowerCase().includes("badgecolour:")) {
              customBadgeColour = tag.toLowerCase().split(":")[1];
            }
          });
        }

        // Custom Time
        if (hasCustomBadgeTime) {
          // Get target time
          cachedTags.forEach(tag => {
            if (tag.toLowerCase().includes("badgetime:")) {
              customBadgeTime = tag.toLowerCase().split(":")[1];

              // Format: mm-dd
              let month = parseInt(customBadgeTime.split("-")[0]);
              let day = parseInt(customBadgeTime.split("-")[1]);
              let year = new Date().getFullYear();

              let nextMonth = "";
              let nextDay = "";
              let nextYear = "";

              // Get month
              switch (month) {
                case 1:
                  month = "Jan";

                  if (day === 31) {
                    nextDay = 1;
                    nextMonth = "Feb";
                    nextYear = year;
                  } else {
                    nextDay = parseInt(day) + 1;
                    nextMonth = month;
                    nextYear = year;
                  }
                  break;
                case 2:
                  month = "Feb";

                  if (day === 29 && leapYear(year)) {
                    nextDay = 1;
                    nextMonth = "Mar";
                    nextYear = year;
                  } else if (day === 28 && !leapYear(year)) {
                    nextDay = 1;
                    nextMonth = "Mar";
                    nextYear = year;
                  } else {
                    nextDay = parseInt(day) + 1;
                    nextMonth = month;
                    nextYear = year;
                  }
                  break;
                case 3:
                  month = "Mar";

                  if (day === 31) {
                    nextDay = 1;
                    nextMonth = "Apr";
                    nextYear = year;
                  } else {
                    nextDay = parseInt(day) + 1;
                    nextMonth = month;
                    nextYear = year;
                  }
                  break;
                case 4:
                  month = "Apr";

                  if (day === 30) {
                    nextDay = 1;
                    nextMonth = "May";
                    nextYear = year;
                  } else {
                    nextDay = parseInt(day) + 1;
                    nextMonth = month;
                    nextYear = year;
                  }
                  break;
                case 5:
                  month = "May";

                  if (day === 31) {
                    nextDay = 1;
                    nextMonth = "Jun";
                    nextYear = year;
                  } else {
                    nextDay = parseInt(day) + 1;
                    nextMonth = month;
                    nextYear = year;
                  }
                  break;
                case 6:
                  month = "Jun";

                  if (day === 30) {
                    nextDay = 1;
                    nextMonth = "Jul";
                    nextYear = year;
                  } else {
                    nextDay = parseInt(day) + 1;
                    nextMonth = month;
                    nextYear = year;
                  }
                  break;
                case 7:
                  month = "Jul";

                  if (day === 31) {
                    nextDay = 1;
                    nextMonth = "Aug";
                    nextYear = year;
                  } else {
                    nextDay = parseInt(day) + 1;
                    nextMonth = month;
                    nextYear = year;
                  }
                  break;
                case 8:
                  month = "Aug";

                  if (day === 31) {
                    nextDay = 1;
                    nextMonth = "Sep";
                    nextYear = year;
                  } else {
                    nextDay = parseInt(day) + 1;
                    nextMonth = month;
                    nextYear = year;
                  }
                  break;
                case 9:
                  month = "Sep";

                  if (day === 30) {
                    nextDay = 1;
                    nextMonth = "Oct";
                    nextYear = year;
                  } else {
                    nextDay = parseInt(day) + 1;
                    nextMonth = month;
                    nextYear = year;
                  }
                  break;
                case 10:
                  month = "Oct";

                  if (day === 31) {
                    nextDay = 1;
                    nextMonth = "Nov";
                    nextYear = year;
                  } else {
                    nextDay = parseInt(day) + 1;
                    nextMonth = month;
                    nextYear = year;
                  }
                  break;
                case 11:
                  month = "Nov";

                  if (day === 30) {
                    nextDay = 1;
                    nextMonth = "Dec";
                    nextYear = year;
                  } else {
                    nextDay = parseInt(day) + 1;
                    nextMonth = month;
                    nextYear = year;
                  }
                  break;
                case 12:
                  month = "Dec";

                  if (day === 31) {
                    nextDay = 1;
                    nextMonth = "Jan";
                    nextYear = year + 1;
                  } else {
                    nextDay = parseInt(day) + 1;
                    nextMonth = month;
                    nextYear = year;
                  }
                  break;
              }

              // Daylight Savings
              if (isDST(new Date())) {
                // console.log(`${day} ${month} ${year} 10:00:00 EDT`);
                // console.log(`${nextDay} ${nextMonth} ${nextYear} 10:00:00 EDT`);
                customBadgeTime = Date.parse(`${day} ${month} ${year} 10:00:00 EDT`);
                customBadgeTimeEnd = Date.parse(`${nextDay} ${nextMonth} ${nextYear} 10:00:00 EDT`);
              } else {
                // console.log(`${day} ${month} ${year} 10:00:00 EDT`);
                // console.log(`${nextDay} ${nextMonth} ${nextYear} 10:00:00 EDT`);
                customBadgeTime = Date.parse(`${day} ${month} ${year} 10:00:00 EST`);
                customBadgeTimeEnd = Date.parse(`${nextDay} ${nextMonth} ${nextYear} 10:00:00 EST`);
              }

              // Check if is active time
              let startTimeRemaining = customBadgeTime - new Date().getTime();
              let endTimeRemaining = customBadgeTimeEnd - new Date().getTime();

              // In active time?
              if (startTimeRemaining < 0 && endTimeRemaining > 0) {
                customBadgeTimeActive = true;
              } else {
                customBadgeTimeActive = false;
              }

              // After active time?
              if (startTimeRemaining < 0) {
                customBadgeTimeStart = true;
              }
            }
          });
        }

        // Create badges
        for (let i = 0; i < badgesToCreate.length; i++) {
          if (badgeCount >= badgeLimit) {
            break;
          }

          let badge = "";

          // If timed badge, only create if within active time window
          // Also not a bundle badge
          if ((badgesToCreate[i] === "STAFF PICK" && customBadgeTimeStart === false && hasCustomBadgeTime) || (hasCustomBadgeTime && !customBadgeTimeActive && badgesToCreate[i] !== bundleBadgeMessage && badgesToCreate[i] !== "STAFF PICK")) {
            continue;
          }

          // Don't use custom badge colour if is a bundle
          if (badgesToCreate[i] !== bundleBadgeMessage) {
            badge = CreateBadge(badgesToCreate[i], customBadgeColour);
          } else {
            badge = CreateBadge(badgesToCreate[i], "");
          }

          // Bundle badge specific
          if (badgesToCreate[i] === bundleBadgeMessage) {
            if (bundleBadgeMessage == "Bundle A") {
              badge.classList.add("tag-badge--bundle-a");
            }
          }

          badgeParent.appendChild(badge);

          badgeCount++;
        }
      }

      if (badgeCount > 0) {
        ShowBadgeParent();
      }
    }

    /*
      Reset Functions
    */
    function ResetBadges() {
      let badges = Array.from(badgeParent.querySelectorAll(".product-details__badge"));

      badges.forEach(badge => {
        if (badge.classList.contains("product-details__badge--sold-out") === false &&
            badge.classList.contains("product-details__badge--coming-soon") === false &&
            badge.classList.contains("product-details__badge--bogo") === false &&
            badge.classList.contains("product-details__badge--low-stock") === false &&
            badge.classList.contains("product-details__badge--percent-off") === false &&
            badge.classList.contains("product-details__badge--on-sale") === false) {
          badge.remove();
        }
      });

      HideSoldoutBadge();
      HideComingSoonBadge();
      HideBogoBadge();
      HideLowStockBadge();
      HidePercentBadge();
      HideSaleBadge();
      HideBadgeParent();
    }

    /*
      State Functions (Public)
    */
    function SetSoldoutBadgeState(quantity = 0, inventoryPolicy = "deny", available = "", isComingSoon = false) {
      if (quantity <= 0 && inventoryPolicy != "continue" && available != "true" && isComingSoon == false) {
        ShowSoldoutBadge();
      } else {
        HideSoldoutBadge();
      }
    }

    function SetComingSoonBadgeState(isComingSoon = false) {
      if (isComingSoon) {
        ShowComingSoonBadge();
      } else {
        HideComingSoonBadge();
      }
    }

    function SetBogoBadgeState(quantity = 0) {
      let isBogo = false;
      let hasMoreThanTwo = false;

      // Get lower + check for bogo tag
      let tagsLower = cachedTags.map(tags => tags.toLowerCase());
      let hasBogo = tagsLower.find(tag => tag === ("BOGO"));

      if (hasBogo) {
        if (quantity >= 2) {
          hasMoreThanTwo = true;
        }
      }

      if (hasBogo && hasMoreThanTwo) {
        isBogo = true;
      }

      if (isBogo) {
        ShowBogoBadge();
      } else {
        HideBogoBadge();
      }
    }

    function SetLowStockBadgeState(quantity = 0) {
      if (quantity <= quantityLimit && quantity > 0 && !isTimeProduct) {
        ShowLowStockBadge(quantity);
      } else {
        HideLowStockBadge();
      }
    }

    function SetPercentBadgeState(price = "", comparePrice = "", isNoPercentOff = false) {
      if (comparePrice === "" || isNoPercentOff === true) {
        HidePercentBadge();
        return;
      }

      // Lower + check for kbundle tag
      let tagsLower = cachedTags.map(tag => tag.toLowerCase());
      let hasKBundle = tagsLower.find(tag => tag.includes("kbundle"));

      let intPrice = parseInt(price);
      let intComparePrice = parseInt(comparePrice);
      let percent = (((intComparePrice - intPrice) * 100) / intComparePrice);

      let onSale = intComparePrice > intPrice;
      let percentBadgeText = "";

      // K bundle or percent
      if (onSale) {
        if (hasKBundle) {
          percentBadgeText = "Bulk Options!";
        } else {
          percentBadgeText = percentBadge.getAttribute("data-percent-off-template").replace("%X", parseFloat(Math.ceil(percent)).toString());
        }
      }

      if (onSale) {
        ShowPercentBadge(percentBadgeText);
      } else {
        HidePercentBadge();
      }
    }

    function SetSaleBadgeState(price = "", comparePrice = "", isNotSale = false) {
      if (isNotSale) {
        HideSaleBadge();
        return;
      }

      if (comparePrice === "") {
        HideSaleBadge();
        return;
      }

      let intPrice = parseInt(price);
      let intComparePrice = parseInt(comparePrice);

      if (intComparePrice > intPrice) {
        ShowSaleBadge();
      } else {
        HideSaleBadge();
      }
    }

    /*
      State Functions (Private)
    */
    // - Hide
    function HideBadgeParent() {
      badgeParent.classList.add("sk-hidden");
      // productTitle.style.marginTop = "0";
    }

    function HideSoldoutBadge() {
      soldoutBadge.classList.add("sk-hidden");
    }

    function HideComingSoonBadge() {
      comingSoonBadge.classList.add("sk-hidden");
    }

    function HideBogoBadge() {
      bogoBadge.classList.add("sk-hidden");
    }

    function HideLowStockBadge() {
      lowStockBadge.classList.add("sk-hidden");
    }

    function HidePercentBadge() {
      percentBadge.classList.add("sk-hidden");
    }

    function HideSaleBadge() {
      saleBadge.classList.add("sk-hidden");
    }

    // - Show
    function ShowBadgeParent() {
      badgeParent.classList.remove("sk-hidden");
      // productTitle.style.marginTop = "4px";
    }

    function ShowSoldoutBadge() {
      soldoutBadge.innerText = soldoutBadge.getAttribute("data-sold-out-template");
      soldoutBadge.classList.remove("sk-hidden");

      ShowBadgeParent();
    }

    function ShowComingSoonBadge() {
      comingSoonBadge.innerText = comingSoonBadge.getAttribute("data-coming-soon-template");
      comingSoonBadge.classList.remove("sk-hidden");

      ShowBadgeParent();
    }

    function ShowBogoBadge() {
      bogoBadge.innerText = bogoBadge.getAttribute("data-bogo-template");
      bogoBadge.classList.remove("sk-hidden");

      ShowBadgeParent();
    }

    function ShowLowStockBadge(quantity = 0) {
      lowStockBadge.innerText = lowStockBadge.getAttribute("data-low-stock-template").replace("%X", quantity);
      lowStockBadge.classList.remove("sk-hidden");

      ShowBadgeParent();
    }

    function ShowPercentBadge(percentText = "") {
      percentBadge.innerText = percentText;
      percentBadge.classList.remove("sk-hidden");

      ShowBadgeParent();
    }

    function ShowSaleBadge() {
      saleBadge.classList.remove("sk-hidden");

      ShowBadgeParent();
    }

    /*
      - Update Functions
    */
    function RefreshBadgeState(variant = {}) {
      let price = variant.price.toString();
      let comparePrice = variant.compare_at_price === null ? "" : variant.compare_at_price.toString();

      let index = document.querySelector("#variant-main-select").selectedIndex;
      if (index < 0) index = 0;

      let quantity = parseInt(document.querySelector("#variant-main-select")[index].getAttribute("data-qty"));
      let inventoryPolicy = document.querySelector("#variant-main-select")[index].getAttribute("data-ipolicy");
      let available = document.querySelector("#variant-main-select")[index].getAttribute("data-available");
      let isComingSoon = document.querySelector("#variant-main-select")[index].getAttribute("data-coming-soon") === "true" ? true : false;

      // Get time product state
      isTimeProduct = document.querySelector(".product-main-content").getAttribute("data-is-time") === "true" ? true : false;

      // Is not sale?
      isNotSale = document.querySelector("#variant-main-select")[index].getAttribute("data-not-sale") === "true" ? true : false;

      // Is no % off?
      isNoPercentOff = document.querySelector(".product-main-content").getAttribute("data-no-percent-off") === "true" ? true : false;

      console.log(price, comparePrice);

      SetSoldoutBadgeState(quantity, inventoryPolicy, available, isComingSoon);
      SetComingSoonBadgeState(isComingSoon);
      SetBogoBadgeState(quantity);
      SetLowStockBadgeState(quantity);
      SetPercentBadgeState(price, comparePrice, isNoPercentOff);
      SetSaleBadgeState(price, comparePrice, isNotSale);

      if (soldoutBadge.classList.contains("sk-hidden") &&
          comingSoonBadge.classList.contains("sk-hidden") &&
          bogoBadge.classList.contains("sk-hidden") &&
          lowStockBadge.classList.contains("sk-hidden") &&
          percentBadge.classList.contains("sk-hidden") &&
          saleBadge.classList.contains("sk-hidden") &&
          badgeParent.children.length <= 6) {
        HideBadgeParent();
      }
    }

    return Object.freeze({
      CreateBadge,
      InitBadges,
      PopulateBadges,
      RefreshBadgeState,
      ResetBadges,
      SetLowStockBadgeState,
      SetPercentBadgeState,
      SetSaleBadgeState,
    });
  })();

  /*
    ====================
    CTA Manager
    ====================
  */
  const CTAManager = (() => {
    // Elements
    let addToCartBtn = document.querySelector(".product-cta-sticky-menu__add-to-cart-btn");
    let addToCartBtnDesktop = document.querySelector(".product-variant-select__add-to-cart-btn");
    let errorMsg = document.querySelector(".product-cta-sticky-menu__error-msg");
    let errorMsgDesktop = document.querySelector(".product-variant-select__error-msg");

    /*
      - Click Event Functions
    */
    async function AddToCart(e = undefined) {
      e.preventDefault();

      let index = document.querySelector("#variant-main-select").selectedIndex;
      if (index < 0) index = 0;

      let vid = document.querySelector(".product-cta-sticky-menu #variant-main-select")[index].getAttribute("value");
      let productData = document.querySelector(`.product-cta-sticky-menu #variant-main-select option[value='${vid}']`);

      let quantity = 1;
      const quantityMax = productData.dataset.quantityMax;

      // bogo
      const isBogo = productData.dataset.isBogo === "true" ? true : false;

      // change quantity if bogo
      // if (isBogo) {
      //   let quantityDouble = quantity * 2;
      //   let policyDeny = quantityMax === -1 ? false : true;
      //   let remainingCount = quantityMax;
      //   let cartCount = 0;

      //   // get quantity in cart
      //   document.querySelectorAll("#cart-side .cart-body .line-items-list .line-item").forEach(function (item) {
      //     if (item.getAttribute("data-vid") === vid) {
      //       if (item.getAttribute("data-is-bogo-side") === "false") {
      //         const cartQuantity = parseInt(item.querySelector(".line-item__col.line-item__col--quantity input[type='number'].quantity-value").value);
      //         cartCount += cartQuantity;
      //       } else if (item.getAttribute("data-is-bogo-side") === "true") {
      //         const cartQuantity = parseInt(item.querySelector(".line-item__col.line-item__col--price .line-item__discount-free").innerText.split(" ")[0]);
      //         cartCount += cartQuantity;
      //       }
      //     }
      //   });

      //   if (remainingCount - cartCount < quantityDouble && policyDeny) {
      //     quantity = quantity;
      //   } else {
      //     quantity = quantityDouble;
      //   }
      // }

      // Limit of One Data Check
      if (productData.dataset.limit === "true") {
        // Get cart data
        const cartData = await Global.Cart.cart();

        if (productData.dataset.limitV === "true") {
          // Limit of One Variant Check (per variant)
          // Check current quantity in cart
          const variantId = parseInt(productData.value);
          const matchingVariant = cartData.items.find(item => item.variant_id === variantId);

          // If quantity > 1, return error
          if (matchingVariant && matchingVariant.quantity > 0) {
            // End Loading
            addToCartBtn.classList.remove("product-cta-sticky-menu__add-to-cart-btn--adding");
            addToCartBtnDesktop.classList.remove("product-variant-select__add-to-cart-btn--adding");

            // Show error
            errorMsg.classList.remove("sk-hidden");
            errorMsg.innerText = "Item limited to 1 per customer!";
            errorMsgDesktop.classList.remove("sk-hidden");
            errorMsgDesktop.innerText = "Item limited to 1 per customer!";

            return;
          }
        } else {
          // Limit of One Product Check (per product)
          // Check current quantity
          const productId = parseInt(productData.dataset.pid);
          const matchingItem = cartData.items.find(item => item.product_id === productId);

          // Exists and exceeds quantity limit?
          if (matchingItem && matchingItem.quantity > 0) {
            // End Loading
            addToCartBtn.classList.remove("product-cta-sticky-menu__add-to-cart-btn--adding");
            addToCartBtnDesktop.classList.remove("product-variant-select__add-to-cart-btn--adding");

            // Show error
            errorMsg.classList.remove("sk-hidden");
            errorMsg.innerText = "Item limited to 1 per customer!";
            errorMsgDesktop.classList.remove("sk-hidden");
            errorMsgDesktop.innerText = "Item limited to 1 per customer!";

            return;
          }
        }
      }

      // Reset error
      errorMsg.classList.add("sk-hidden");
      errorMsg.innerText = "";
      errorMsgDesktop.classList.add("sk-hidden");
      errorMsgDesktop.innerText = "";

      // Show loading
      addToCartBtn.classList.add("product-cta-sticky-menu__add-to-cart-btn--adding");
      addToCartBtnDesktop.classList.add("product-variant-select__add-to-cart-btn--adding");

      //adds to cart, refreshes the sidecart and shows the sidecart
      Global.Cart.add({id: vid, quantity: quantity})
      .then(res => {
        const quantityInCart = res.items[0].quantity;
        const isDesktop = window.matchMedia("only screen and (min-width: 768px)").matches;

        Global.SideCart.refresh();

        // if (isDesktop) {
        //   Global.SideCart.show();
        // } else {
          // setup data for notification popup
          const comparePriceText = productData.dataset.comparePrice;
          const priceText = productData.dataset.price;
          const url = productData.dataset.url;
          const imageSrc = productData.dataset.variantSrc;
          const variantTitle = productData.dataset.title;

          NotificationPopups.show({
            comparePrice: comparePriceText,
            link: url,
            price: priceText,
            quantity: quantity,
            src: imageSrc,
            variantTitle: variantTitle,
            quantityCart: quantityInCart,
            quantityMax: quantityMax,
            variantId: vid,
          });
        // }

        // End Loading
        addToCartBtn.classList.remove("product-cta-sticky-menu__add-to-cart-btn--adding");
        addToCartBtnDesktop.classList.remove("product-variant-select__add-to-cart-btn--adding");
      })
      .catch(res => {
        // End Loading
        addToCartBtn.classList.remove("product-cta-sticky-menu__add-to-cart-btn--adding");
        addToCartBtnDesktop.classList.remove("product-variant-select__add-to-cart-btn--adding");

        if (res.description.includes("You can't add more") &&
            res.description.includes("to the cart")) {
          errorMsg.classList.remove("sk-hidden");
          errorMsg.innerText = "Not enough inventory. Try again with a lower quantity.";
          errorMsgDesktop.classList.remove("sk-hidden");
          errorMsgDesktop.innerText = "Not enough inventory. Try again with a lower quantity.";
        } else if (res.description.includes("All") &&
            res.description.includes("are in your cart")) {
          errorMsg.classList.remove("sk-hidden");
          errorMsg.innerText = "All remaining inventory is in the cart already.";
          errorMsgDesktop.classList.remove("sk-hidden");
          errorMsgDesktop.innerText = "All remaining inventory is in the cart already.";
        } else if (res.status == 422 && res.message.includes("Item limit reached")) {
          errorMsg.classList.remove("sk-hidden");
          errorMsg.innerText = res.message;
          errorMsgDesktop.classList.remove("sk-hidden");
          errorMsgDesktop.innerText = res.message;
        } else if (res.status == 422 && res.message.includes("Must have a non-free product in the cart")) {
          errorMsg.classList.remove("sk-hidden");
          errorMsg.innerText = res.message;
          errorMsgDesktop.classList.remove("sk-hidden");
          errorMsgDesktop.innerText = res.message;
        } else {
          errorMsg.classList.remove("sk-hidden");
          errorMsg.innerText = "An error occurred. Please try again soon.";
          errorMsgDesktop.classList.remove("sk-hidden");
          errorMsgDesktop.innerText = "An error occurred. Please try again soon.";
        }
        return;
      });
    }

    /*
      - Notify Me Functions
    */
    let notifyMeTimeout = undefined;

    function HideNotifyModal(e = undefined) {
      // TODO
    }

    function ShowNotifyModal(e = undefined) {
      if (e) e.preventDefault();

      if (notifyMeTimeout) clearTimeout(notifyMeTimeout);

      try {
        let index = document.querySelector("#variant-main-select").selectedIndex;
        if (index < 0) index = 0;

        document.querySelector("#variant-main-select")[index].getAttribute("value")
        let pUrl = window.location.href.split("?")[0];
        let pid = document.querySelector("#variant-main-select")[index].getAttribute("data-pid")
        let vid = document.querySelector("#variant-main-select")[index].getAttribute("value");

        let params = {
          empi: pid,
          epi: vid,
          du: pUrl,
        };

        // Shows notify me
        _swat.getProductDetails(params, function(productJSON) {
          productJSON.variants.forEach(function(v) {
            if (v.id == vid) {
              params.pr = SwymUtils.formatProductPrice(v.price);
              params.iu = productJSON.featured_image;
              params.et = 8;
              _swat.addToWatchList(e, params, function(e) {
                console.log("Subscribed to product!", e);
              }); // Shows Subscribe me.
              return;
            }

          });
        });
      } catch (err) {
        notifyMeTimeout = setTimeout(() => {
          ShowNotifyModal(e);
        }, 500);
      }
    }

    /*
      - State Functions
    */
    function SetCTAState(available = true) {
      // Get time state
      const isTimeProduct = document.querySelector(".product-main-content").getAttribute("data-is-time") === "true" ? true : false;

      if (!available) {
        addToCartBtn.classList.add("product-cta-sticky-menu__add-to-cart-btn--sold-out");
        addToCartBtnDesktop.classList.add("product-variant-select__add-to-cart-btn--sold-out");

        // if (!isTimeProduct) {
          addToCartBtn.addEventListener("click", ShowNotifyModal);
          addToCartBtnDesktop.addEventListener("click", ShowNotifyModal);
        // } else {
        //   addToCartBtn.classList.add("is-time-product");
        //   addToCartBtnDesktop.classList.add("is-time-product");
        // }

        addToCartBtn.removeEventListener("click", AddToCart);
        addToCartBtnDesktop.removeEventListener("click", AddToCart);

        // Hide quick pay if exists
        let quickPayContainer = document.querySelector(".pseudo-quick-checkout-buttons");
        if (quickPayContainer) quickPayContainer.classList.add("disabled");
        let morePayContainer = document.querySelector("form > .shopify-payment-button__more-options");
        if (morePayContainer) morePayContainer.classList.add("disabled");

        let quickPayContainerDesktop = document.querySelector(".pseudo-quick-checkout-buttons.sk-large");
        if (quickPayContainerDesktop) quickPayContainerDesktop.classList.add("disabled");
      } else {
        addToCartBtn.classList.remove("product-cta-sticky-menu__add-to-cart-btn--sold-out");
        addToCartBtnDesktop.classList.remove("product-variant-select__add-to-cart-btn--sold-out");

        // if (!isTimeProduct) {
          addToCartBtn.removeEventListener("click", ShowNotifyModal);
          addToCartBtnDesktop.removeEventListener("click", ShowNotifyModal);
        // } else {
        //   addToCartBtn.classList.remove("is-time-product");
        //   addToCartBtnDesktop.classList.remove("is-time-product");
        // }

        addToCartBtn.addEventListener("click", AddToCart);
        addToCartBtnDesktop.addEventListener("click", AddToCart);

        // Show quick pay if exists
        let quickPayContainer = document.querySelector(".pseudo-quick-checkout-buttons");
        if (quickPayContainer) quickPayContainer.classList.remove("disabled");
        let morePayContainer = document.querySelector("form > .shopify-payment-button__more-options");
        if (morePayContainer) morePayContainer.classList.remove("disabled");

        let quickPayContainerDesktop = document.querySelector(".pseudo-quick-checkout-buttons.sk-large");
        if (quickPayContainerDesktop) quickPayContainerDesktop.classList.remove("disabled");
      }
    }

    function SetCTAVariant(id = 0) {
      addToCartBtn.setAttribute("data-vid", id);
      addToCartBtnDesktop.setAttribute("data-vid", id);
    }

    return Object.freeze({
      AddToCart,
      HideNotifyModal,
      ShowNotifyModal,
      SetCTAState,
      SetCTAVariant,
    });
  })();

  /*
    ====================
    Description Box
    ====================
  */
  const DescriptionBox = (() => {
    const DEBUG = true;

    let descriptionBox = undefined;
    let descriptionItemHeaders = undefined;

    /* Functions */
    // Hide
    function hide(target) {
      target.parentElement.classList.remove("active");
      target.nextElementSibling.style.maxHeight = "0";
    }

    // Hide all
    function hideAll() {
      descriptionItemHeaders.forEach(item => {
        hide(item);
      });
    }

    // Show
    function show(target) {
      // Hide all other items
      hideAll();

      // Set target as active
      target.parentElement.classList.add("active");
      target.nextElementSibling.style.maxHeight = `${target.nextElementSibling.scrollHeight}px`;
    }

    /* Handlers */
    // Handle click
    function clickHandler(e) {
      e.preventDefault();

      // Toggle
      if (e.currentTarget.parentElement.classList.contains("active")) {
        hide(e.currentTarget);
      } else {
        show(e.currentTarget);
      }
    }

    /* Init */
    function Init() {
      // Elements
      descriptionBox = document.querySelector(".product-main__section-root .product-details__accordion-desc");

      if (!descriptionBox) {
        if (DEBUG) {
          console.warn("No description box found");
        }

        return;
      }

      descriptionItemHeaders = descriptionBox.querySelectorAll(".description-item .header");

      // Add click listeners
      descriptionItemHeaders.forEach(item => {
        item.addEventListener("click", clickHandler);
      });

      // Show first item
      const activeItem = document.querySelector(".description-item.active .header");

      if (activeItem) {
        show(activeItem);

        // Remove active start
        setTimeout(() => activeItem.parentElement.classList.remove("active--start"), 100);
      }
    }

    return Object.freeze({
      Init,
    });
  })();

  /*
    ====================
    Gift with Purchase
    ====================
  */
  const GiftWithPurchase = (() => {
    /* Init */
    // To allow clicking the "View details" hyperlink to open the product-gift-with-purchase-modal
    function Init() {
      const giftWithPurchaseViewDetailsLink = document.querySelectorAll(".gift-with-purchase-view-details-link");
      giftWithPurchaseViewDetailsLink.forEach(link => {
        link.addEventListener("click", e => {
        e.preventDefault();

        try {
          ProductGiftWithPurchaseModal.show();
        } catch (e) {
          console.warn(e);
        }
        })
      });
    }

    return Object.freeze({
      Init,
    });
  })();

  /*
    ====================
    Gallery Manager
    ====================
  */
  const GalleryManager = (() => {
    // Elements
    let gallerySwiper = undefined;


    // Desktop Gallery
    let images = undefined;
    let galleryItemContainers = undefined;

    /* - Zoom */
    let imageRect = undefined;
    let zoomedImage = undefined;


    // Desktop Pagination
    let list = undefined;
    let smallGroupIndexMax = 0;
    let largeGroupIndexMax = 0;

    let items = undefined;

    // Params
    const largeScreenMediaRule = "only screen and (min-width: 1060px)";

    // Mobile
    // Modal
    let modal = undefined;
    let overlayBg = undefined;

    let modalCloseBtn = undefined;
    let modalImageView = undefined;

    let modalPrevBtn = undefined;
    let modalNextBtn = undefined;

    let modalTimeout = undefined;
    let modalHideDuration = 100;
    let modalShowDuration = 100;

    // Items
    let mobileItems = undefined;


    /*
      - Init Functions
    */
    function InitGallery(imgs = []) {
      if (imgs.length > 1) {
        InitDesktopGallery();
        InitDesktopPagination();
        InitMobileGallerySwiper(imgs);
        InitMobileGalleryModal();
      }
    }

    function InitDesktopGallery() {
      // Elements
      /* - Zoom */
      images = Array.from(document.querySelectorAll(".product-gallery.sk-desktop .gallery-item-container .column"));
      galleryItemContainers = Array.from(document.querySelectorAll(".product-gallery.sk-desktop .gallery-item-container"));

      // Event listeners
      /* - Zoom */
      if (images) {
        images.forEach(image => {
          image.addEventListener("mouseenter", mouseEnterHandler);
          image.addEventListener("mousemove", mouseMoveHandler);
        });
      }
    }

    function InitDesktopPagination() {
      const isLargeScreen = window.matchMedia(largeScreenMediaRule).matches;

      /* Elements */
      list = document.querySelector(".product-gallery__pagination.sk-desktop .pagination-list");
      items = Array.from(document.querySelectorAll(".product-gallery__pagination.sk-desktop .pagination-item"));

      // Index data
      currentIndex = parseInt(list.getAttribute("data-current-index"));
      smallGroupIndexMax = parseInt(list.getAttribute("data-small-group-index-max"));
      largeGroupIndexMax = parseInt(list.getAttribute("data-large-group-index-max"));

      // Item Click Listener
      items.forEach(item => {
        item.addEventListener("click", itemClickHandler);
      });

      // Resize
      window.addEventListener("resize", resizeHandler);

      // Init pagination list view
      if (isLargeScreen) {
        list.classList.add("pagination-list--large");
      } else if (!isLargeScreen) {
        list.classList.remove("pagination-list--large");
      }
    }

    function InitMobileGallerySwiper(images = []) {
      if (images.length > 0) {
        gallerySwiper = new Swiper('.product-gallery.sk-mobile', {
          direction: 'horizontal',
          grabCursor: false,
          loop: false,
          freeMode: true,
          centeredSlides: false,
          slidesPerView: 1.6,
          spaceBetween: 4,
          threshold: 5,
          focusableElements: "#sk-none",
          mousewheel: {
            forceToAxis: true,
          },
          pagination: {
            el: '.product-gallery.sk-mobile .product-gallery__pagination',
            clickable: true
          },
          breakpoints: {
            600: {
              slidesPerView: 2.4
            },
            800: {
              slidesPerView: 3.4
            }
          }
        });
      }
    }

    function InitMobileGalleryModal() {
      // Modal
      modal = document.querySelector(".gallery-modal");
      overlayMain = document.querySelector("#overlay-main");
      overlayBg = document.querySelector("#overlay-bg");

      // Move modal to root modal
      modal.remove();
      overlayMain.appendChild(modal);

      // Close btn
      modalCloseBtn = document.querySelector(".gallery-modal .close-btn");
      modalCloseBtn.addEventListener("click", closeBtnClickHandler);

      // Image view
      modalImageView = document.querySelector(".gallery-modal .image-view");

      // Prev and Next
      modalPrevBtn = document.querySelector(".gallery-modal .prev-arrow");
      modalNextBtn = document.querySelector(".gallery-modal .next-arrow");

      try {
        modalPrevBtn.addEventListener("click", prevBtnClickHandler);
        modalNextBtn.addEventListener("click", nextBtnClickHandler);
      } catch (e) {
        if (DEBUG) {
          console.warn("Could not find next or prev btn");
        }
      }

      // Items
      mobileItems = document.querySelectorAll(".product-gallery.sk-mobile .gallery-item");

      mobileItems.forEach(item => {
        item.addEventListener("click", mobileModalItemClickHandler);
      });
    }

    /*
      - Update Functions
    */
    function SlideToSelectedVariant(imageId = 0) {
      if (imageId) {
        let featuredImage = document.querySelector(`.product-gallery.sk-mobile .swiper-slide img[data-image-id='${imageId}']`);

        if (featuredImage) {
          gallerySwiper.slideTo(parseInt(featuredImage.getAttribute("data-index")), 500, true);
        }
      }
    }

    function SetActiveById(imageId = 0) {
      // Get new active
      const newActive = Array.from(document.querySelectorAll(".product-gallery__pagination.sk-desktop .pagination-item")).find(item => parseInt(item.getAttribute("data-image-id")) === parseInt(imageId));

      if (!newActive) return;

      // desktop
      let newActiveFound = false;

      galleryItemContainers.forEach(galleryItemContainer => {
        galleryItemContainer.classList.remove("active", "prev", "next");

        // If anything changes to the nested elements within gallery-item-container, this won't work.
        // At the moment this code is written, gallery-item-container -> row -> column, column
        const rowDiv = galleryItemContainer.firstElementChild;

        for (let columnDiv of Array.from(rowDiv.children)) {
          if (columnDiv.children.length > 0) {
            // Zoomed image and regular image both have the same data-image-id set, so doesn't matter if first element child of column div
            const dataImageId = columnDiv.firstElementChild.getAttribute("data-image-id");

            // if it is the left image (1st iteration of this for loop) that matches, can skip to the next container,
            // if it is the right image (2nd and last iteration of this for loop), it'll overwrite what the left image set.
            if (dataImageId === imageId) {
              // Set active
              galleryItemContainer.classList.add("active");
              newActiveFound = true;
              break;
            } else {
              // Reset image
              galleryItemContainer.classList.remove("active", "prev", "next");

              // Set either prev or next based on order
              if (!newActiveFound) {
                // Not found yet, set as prev
                galleryItemContainer.classList.add("prev");
              } else {
                // Found, set as next
                galleryItemContainer.classList.add("next");
              }
            }
          }
        }
      });

      // pagination
      try {
        // Clear active
        list.querySelector(".active").classList.remove("active");

        // Set new as active
        newActive.classList.add("active");
      } catch (e) {
        if (DEBUG) {
          console.warn("Could not find active item or image id", e);
        }
      }

      SlideToSelectedVariant(imageId);
    }

    // Desktop
    /* - Zoom */
    function zoomImageToPosition(image, x, y, scale) {
      image.style = `transform: translate(${x}%, ${y}%) scale(${scale}) !important`;
    }

    /* Handlers */
    /* - Zoom */
    function mouseEnterHandler(e) {
      // Init
      const target = e.currentTarget;

      imageRect = target.getBoundingClientRect();
      zoomedImage = target.querySelector(".gallery-item__zoomed");
      if (zoomedImage === null) {
        zoomedImage = target.querySelector(".gallery-item-right__zoomed");
      }
    }

    function mouseMoveHandler(e) {
      if (zoomedImage) {
        // Init
        const target = e.currentTarget;
        const scale = 1.5;

        // Image position
        const imageLeftOffset = imageRect.left;
        const imageTopOffset = imageRect.top;

        // Image dimensions
        const imageWidth = target.offsetWidth;
        const imageHeight = target.offsetHeight;

        // Mouse position
        const mouseX = e.clientX;
        const mouseY = e.clientY;

        const mousePosX = mouseX - imageLeftOffset;
        const mousePosY = mouseY - imageTopOffset;

        const mouseXPercent = -(((mousePosX / imageWidth) - 0.5) * 100) * 0.5;
        const mouseYPercent = -(((mousePosY / imageHeight) - 0.5) * 100) * 0.5;

        // Move
        zoomImageToPosition(zoomedImage, mouseXPercent, mouseYPercent, scale);
      }
    }

    // Pagination

    /* Handlers */
    /* - Desktop Pagination */
    function itemClickHandler(e) {
      e.preventDefault();

      // Init
      const target = e.currentTarget;

      // Find active
      const currentActive = target.parentElement.querySelector(".active");

      // Clear active
      currentActive.classList.remove("active");

      // Set target as active
      target.classList.add("active");
      SetActiveById(target.getAttribute("data-image-id"));
    }

    function resizeHandler(e) {
      // Screen size
      const isLargeScreen = window.matchMedia(largeScreenMediaRule).matches;

      if (isLargeScreen &&
          !list.classList.contains("pagination-list--large") &&
          parseInt(list.getAttribute("data-current-index")) > 0) {
        // Reset current index
        list.setAttribute("data-current-index", "0");

        // Move to top
        list.style.transform = "translateY(0)";

        // Set state
        list.classList.add("pagination-list--large");
      } else if (!isLargeScreen &&
        list.classList.contains("pagination-list--large") &&
        parseInt(list.getAttribute("data-current-index")) > 0) {
        // Reset current index
        list.setAttribute("data-current-index", "0");

        // Move to top
        list.style.transform = "translateY(0)";

        // Set state
        list.classList.remove("pagination-list--large");
      }
    }

    // Mobile
    // Hide
    function hide() {
      if (modal.getElementsByTagName('video').length > 0) {
        for (const video of modal.getElementsByTagName('video')) {
          video.pause();
        }
      }

      modal.classList.remove("active");

      if (modalTimeout) {
        clearTimeout(modalTimeout);
      }

      modalTimeout = setTimeout(() => {
        Global.Overlay.Background.hide();
        modal.classList.add("sk-hidden");
      }, modalHideDuration);

      // Overlay
      overlayBg.removeEventListener("click", overlayBgClickHandler);
      document.removeEventListener("keydown", modalKeydownHandler);
    }

    // Next
    function next() {
      const childElement = modalImageView.firstElementChild;
      let currentSrc;
      if (modalImageView.getElementsByTagName('video').length > 0) {
        for (const video of modalImageView.getElementsByTagName('video')) {
          currentSrc = video.firstElementChild.getAttribute("src");
        }
      }
      else {
        currentSrc = childElement.getAttribute("src");
      }

      let currentImg;
      if (document.querySelector(`.product-gallery.sk-mobile .gallery-item[data-src='${currentSrc}']`)) {
        currentImg = document.querySelector(`.product-gallery.sk-mobile .gallery-item[data-src='${currentSrc}']`);
      }
      else {
        currentImg = document.querySelector(`.product-gallery.sk-mobile .gallery-item[src='${currentSrc}']`);
      }

      let nextImg = undefined;
      if (parseInt(currentImg.getAttribute("data-index")) === parseInt(currentImg.getAttribute("data-index-last"))) {
        // Set next active to be first image
        nextImg = currentImg.parentElement.parentElement.firstElementChild.firstElementChild;
      } else {
        nextImg = currentImg.parentElement.nextElementSibling.firstElementChild;
      }

      if (!nextImg) {
        if (DEBUG) {
          console.warn("Could not find next image");
        }

        return;
      }

      const src = nextImg.getAttribute("data-src");
      const mediaType = nextImg.getAttribute("data-media-type");

      setActiveByMediaType(mediaType, src);
    }

    // Prev
    function prev() {
      const childElement = modalImageView.firstElementChild;
      let currentSrc;
      if (modalImageView.getElementsByTagName('video').length > 0) {
        for (const video of modalImageView.getElementsByTagName('video')) {
          currentSrc = video.firstElementChild.getAttribute("src");
        }
      }
      else {
        currentSrc = childElement.getAttribute("src");
      }

      let currentImg;
      if (document.querySelector(`.product-gallery.sk-mobile .gallery-item[data-src='${currentSrc}']`)) {
        currentImg = document.querySelector(`.product-gallery.sk-mobile .gallery-item[data-src='${currentSrc}']`);
      }
      else {
        currentImg = document.querySelector(`.product-gallery.sk-mobile .gallery-item[src='${currentSrc}']`);
      }

      let prevImg = undefined;

      if (parseInt(currentImg.getAttribute("data-index")) === 0) {
        // Set next active to be last image
        prevImg = currentImg.parentElement.parentElement.lastElementChild.firstElementChild;
      } else {
        prevImg = currentImg.parentElement.previousElementSibling.firstElementChild;
      }

      if (!prevImg) {
        if (DEBUG) {
          console.warn("Could not find prev image");
        }

        return;
      }

      const src = prevImg.getAttribute("data-src");
      const mediaType = prevImg.getAttribute("data-media-type");

      setActiveByMediaType(mediaType, src);
    }

    // Set Active
    function setActiveByMediaType(type, src="") {
      const childElement = modalImageView.firstElementChild;
      if (modalImageView.getElementsByTagName('img').length > 0 || modalImageView.getElementsByTagName('video').length > 0) {
        modalImageView.removeChild(childElement);
      }

      if ("video" === type) {
        const videoElement = document.createElement("video");
        videoElement.setAttribute("controls", true);
        videoElement.setAttribute("controlsList", "nodownload");
        videoElement.setAttribute("height", "100%");
        videoElement.setAttribute("width", "100%");
        videoElement.autoplay = true;

        const videoSourceElement = document.createElement("source");
        videoSourceElement.setAttribute("src", src);

        modalImageView.appendChild(videoElement);
        videoElement.appendChild(videoSourceElement);
      }
      else {
        const imgElement = document.createElement("img");
        imgElement.setAttribute("src", src);
        modalImageView.appendChild(imgElement);
      }
    }

    // Show
    function show() {
      Global.Overlay.Background.show();
      modal.classList.remove("sk-hidden");

      if (modalTimeout) {
        clearTimeout(modalTimeout);
      }

      modalTimeout = setTimeout(() => {
        modal.classList.add("active");

        // Focus next button
        modalNextBtn.focus();
      }, modalShowDuration);

      // Overlay click
      overlayBg.addEventListener("click", overlayBgClickHandler);
      document.addEventListener("keydown", modalKeydownHandler);
    }

    /* Handlers */
    // Click handler
    function mobileModalItemClickHandler(e) {
      e.preventDefault();

      const target = e.currentTarget;
      const src = target.getAttribute("data-src");
      const mediaType = target.getAttribute("data-media-type");

      setActiveByMediaType(mediaType, src);
      show();
    }

    function closeBtnClickHandler(e) {
      e.preventDefault();
      hide();
    }

    function nextBtnClickHandler(e) {
      e.preventDefault();
      next();
    }

    function prevBtnClickHandler(e) {
      e.preventDefault();
      prev();
    }

    function overlayBgClickHandler(e) {
      hide();
    }

    function modalKeydownHandler(e) {
      if (e.code === "Escape") {
        e.preventDefault();
        hide();
      }
    }

    return Object.freeze({
      InitGallery,
      SetActiveById,
      SlideToSelectedVariant,
      setActiveByMediaType
    })
  })();

  /* Notify Me */

  /* Scroll Past Sliver Banner */
  const ScrollPastSliverBanner = (() => {
    const largeScreenMediaRule = "only screen and (min-width: 768px)";

    /* Init */
    function init() {
      // If desktop, don't scroll
      if (window.matchMedia(largeScreenMediaRule).matches) {
        return;
      }

      const productMain = document.querySelector(".product-main__section-root");
      const header = document.querySelector(".header-root");
      let breadcrumbsHeight = 31;

      window.scrollTo({
        top: productMain.offsetTop - header.getBoundingClientRect().height + breadcrumbsHeight,
        left: 0,
        behavior: "smooth"
      });
    }

    return Object.freeze({
      init,
    });
  })();

  /*
    ====================
    Price Manager
    ====================
  */
  const PriceManager = (() => {
    let priceContainer = document.querySelector(".product-details .prices");

    let priceElem = document.querySelector(".product-details .prices .price");
    let comparePriceElem = document.querySelector(".product-details .prices .compare-price");

    /*
      Convert Functions
    */
    /**
     * Format Currency:
     * - Takes a price and a quantity and returns a price in that same format against the quantity
     * - The amounts we are working with are without the delimiters -- just the amount
     * - That means we must find an example to work with first before we know how to format it
     * - The example must be consistent across all product pages
     */
    function FormatCurrency(amount = "", quantity = 1) {
      let symbol = document.body.dataset.currencySymbol;

      // Assumption: Prices are either delimited by , or .
      // Find delimiter
      // The example we are using is from the price itself, which should contain a version of the price that is in the correct format
      let example = document.querySelector(".product-main-content .prices .price");

      if (!example) {
        console.warn("No example price found.");
        return amount;
      }

      // Check if amount is zero (free)
      if (amount === "0" || parseInt(amount) === 0) {
        return "FREE";
      }

      example = example.dataset.price.replace(symbol, "");
      let delimiter = "";

      if (example.includes(".")) {
        delimiter = ".";
      } else if (example.includes(",")) {
        delimiter = ",";
      }

      // Find size of second half of price
      let secondarySize = example.split(delimiter)[1].length;

      if (delimiter !== "") {
        amount = amount.toString();

        // Parameters
        let primary = amount.slice(0, amount.length - secondarySize);
        let secondary = amount.slice(amount.length - secondarySize, amount.length);

        // Calculate new price
        primary = parseInt(primary) * quantity;
        secondary = parseInt(secondary) * quantity;

        // Put overflow from secondary into primary + apply to secondary
        primary += Math.floor(secondary / Math.pow(10, secondarySize));
        secondary = secondary % Math.pow(10, secondarySize);

        // Convert to string
        primary = primary.toString();
        secondary = secondary.toString();

        // Secondary must have enough 0s
        while (secondary.length < secondarySize) {
          secondary = "0" + secondary;
        }

        // Put back together and return
        return `${symbol}${primary}${delimiter}${secondary}`;
      }
    }

    /*
      State Functions
    */
    function SetComparePrice(comparePrice = "") {
      if (comparePrice !== "") {
        comparePriceElem.innerText = `${FormatCurrency(comparePrice, 1)}`;
      } else {
        comparePriceElem.innerText = "";
      }
    }

    function SetPrice(price = "") {
      priceElem.innerText = `${FormatCurrency(price, 1)}`;
    }

    function SetPriceState(price = "", comparePrice = "", available = true) {
      let isCompare = parseInt(price) < parseInt(comparePrice);

      priceContainer.classList.remove("prices--sold-out");
      priceContainer.classList.remove("prices--compare");

      if (!available) {
        priceContainer.classList.add("prices--sold-out");
      }

      if (isCompare) {
        priceContainer.classList.add("prices--compare");
      }
    }

    return Object.freeze({
      SetComparePrice,
      SetPrice,
      SetPriceState,
    })
  })();

  /*
    ====================
    Variant Manager
    ====================
  */
  const VariantManager = (() => {
    // Elements
    let errorMsg = document.querySelector(".product-cta-sticky-menu__error-msg");
    let errorMsgDesktop = document.querySelector(".product-variant-select__error-msg");

    let lowStockThreshold = 3;
    let firstTime = true;

    /*
      Init Functions
    */
    function InitVariantSelectors() {
      errorMsg.classList.add("sk-hidden");
      errorMsgDesktop.classList.add("sk-hidden");
      firstTime = true;
      VariantSelectors.init();
    }

    /*
      State Functions
    */
    function SetActiveVariant(variant = {}) {
      // Prices
      let price = variant.price.toString();
      let comparePrice = variant.compare_at_price !== null ? variant.compare_at_price.toString() : "";

      BadgeManager.RefreshBadgeState(variant);

      CTAManager.SetCTAState(variant.available);
      CTAManager.SetCTAVariant(variant.id);

      PriceManager.SetPrice(price);
      PriceManager.SetComparePrice(comparePrice);

      PriceManager.SetPriceState(price, comparePrice, variant.available);

      if (!firstTime) {
        let option = document.querySelector(`.product-main-content .main-variant-select-desktop option[value='${variant.id}']`);

        if (option) {
          let imageId = option.getAttribute("data-image-id");
          GalleryManager.SetActiveById(imageId);
        }
      }

      firstTime = false;

      // Update swym
      if (window.triggerSwymVariantEvent) {
        setTimeout(() => {
          window.triggerSwymVariantEvent(variant.id);

          setTimeout(() => {
            // Set active wishlist
            WishlistManager.SetWishlistState(variant.id);
          });
        }, 500);
      } else {
        console.warn("Could not find trigger Swym");
      }

      errorMsg.classList.add("sk-hidden");
      errorMsgDesktop.classList.add("sk-hidden");
    }

    return Object.freeze({
      InitVariantSelectors,
      SetActiveVariant,
    });
  })();

  /*
    ====================
    Variant Selector - from product-main.js
    ====================
  */
  let VariantSelectors = (() => {
    let DEBUG = true;

    // Variant Count
    let variantsExist = false;
    let multiVariantsExist = false;

    let MainSelect = undefined;
    let CustomSelects = undefined;
    let MobileSelects = undefined;

    // Init
    function init() {
      MainSelect = CreateMainSelect();
      CustomSelects = CreateCustomSelects();
      MobileSelects = CreateMobileSelects();

      variantsExist = MainSelect.options.length > 1;
      multiVariantsExist = CustomSelects.length > 1 || MobileSelects.length > 1;

      MainSelect.dispatchEvent(new Event("change"));
    }

    /**
     * Main Select Object
     */
    let CreateMainSelect = () => {
      // Main Select
      const MainSelect = document.querySelector(".product-cta-sticky-menu .main-variant-select");
      const MainSelectDesktop = document.querySelector(".product-variant-select .main-variant-select-desktop");

      // Init
      function init() {
        // Custom
        MainSelect._skCustom = Object.freeze({
          getActiveOption,
          setActiveByVIndexAndName,
        });

        return MainSelect;
      }

      // Get
      /**
       * Retrieves current active option
       */
      function getActiveOption() {
        let selectedIndex = MainSelect.selectedIndex;

        // Sold out check
        if (selectedIndex < 0) {
          selectedIndex = 0;
        }

        return MainSelect.options[selectedIndex];
      }

      // Set
      /**
       * Sets active option by provided variant index and name of variant
       */
      function setActiveByVIndexAndName({index = 0, name = ""} = {}) {
        // Empty name check
        if (name === "") {
          if (DEBUG) {
            console.warn("No name found");
          }

          return;
        }

        // Variant check
        if (variantsExist === false) {
          if (DEBUG) {
            console.warn("No other variants found");
          }

          return;
        }

        const variantSize = parseInt(document.querySelector(".options-list").getAttribute("data-size"));

        // Get current title and variant name to replace
        let currVariantTitle = getActiveOption().getAttribute("data-title");
        let oldVariantName = name;
        let newVariantTitle = name;

        // If more than 1 variant, split by /
        if (variantSize > 1) {
          oldVariantName = currVariantTitle.split(" / ")[index];

          // Create variant title
          newVariantTitle = currVariantTitle.replace(oldVariantName, name);
        }

        // Get matching option
        const matchingOption = Array.from(MainSelect.options).find(option => option.getAttribute("data-title") === newVariantTitle);

        if (!matchingOption) {
          if (DEBUG) {
            console.warn("Matching variant not found");
          }

          return;
        }

        // Set active
        MainSelect.selectedIndex = matchingOption.index;
        MainSelectDesktop.selectedIndex = matchingOption.index;

        let price = matchingOption.getAttribute("data-price").replace(",", "").replace(".", "");
        let comparePrice = matchingOption.getAttribute("data-compare-price") !== "" ? matchingOption.getAttribute("data-compare-price").replace(",", "").replace(".", "") : null;

        VariantManager.SetActiveVariant({
          price: price,
          compare_at_price: comparePrice,
          available: matchingOption.getAttribute("data-available") === "true" ? true : false,
          id: parseInt(matchingOption.getAttribute("value")),
          featured_image: matchingOption.getAttribute("data-variant-src"),
          featured_media: {
            position: matchingOption.getAttribute("data-image-position"),
          }
        });

        if (DEBUG) {
          console.log(`Set ${matchingOption.index} as active`);
        }

        // Fire change event
        MainSelect.dispatchEvent(new Event("change"));
      }

      return init();
    }

    /**
     * Custom Select Object
     */
    let CreateCustomSelects = () => {
      // All Custom Selects
      const CustomSelects = Array.from(document.querySelectorAll(".custom-select-container.sk-desktop"));

      // Init
      function init() {
        // Get time state
        let isTimeProduct = document.querySelector(".product-main-content").getAttribute("data-is-time") === "true" ? true : false;

        CustomSelects.forEach(select => {
          // Custom
          const active = select.querySelector(".custom-select-active");
          const options = Array.from(select.querySelectorAll(".custom-select-list .custom-select-option"));

          // Events
          active.addEventListener("click", selectClickHandler);

          // Update options
          options.forEach(option => {
            // Events
            option.addEventListener("click", optionClickHandler);
            option.addEventListener("keydown", optionKeydownHandler);
          });

          // Set low stock and sold out states IF only one option type
          if (CustomSelects.length === 1) {
            options.forEach(option => {
              let available = false;
              let lowstock = false;

              let variant;
              if (option.getAttribute("data-val").includes("'")) {
                variant = document.querySelector(`.main-variant-select option[data-title="${option.getAttribute("data-val")}"]`);
              }
              else {
                variant = document.querySelector(`.main-variant-select option[data-title='${option.getAttribute("data-val")}']`);
              }

              available = variant.getAttribute("data-available") === "true";
              lowstock = variant.getAttribute("data-low-stock") === "true";

              if (!available) {
                option.classList.add("sold-out");
              } else if (lowstock && !isTimeProduct) {
                option.classList.add("low-stock");
              }
            });
          }

          select._skCustom = Object.freeze({
            active,
            options,
          });
        });

        // Events
        MainSelect.addEventListener("change", updateAllActiveToMainSelect);
        window.addEventListener("resize", resizeHandler);

        return CustomSelects;
      }

      // Visibility
      /**
       * Hide All Selects
       */
      function hideAllSelects() {
        CustomSelects.forEach(select => select.classList.remove("active"));
      }

      // Handlers - Custom Select
      /**
       * Main Select change handler
       * This is the bulk of how custom select is updated
       */
      function updateAllActiveToMainSelect(e) {
        const activeOption = MainSelect._skCustom.getActiveOption();

        // Get coming soon
        let index = document.querySelector("#variant-main-select").selectedIndex;
        if (index < 0) index = 0;
        const isComingSoon = document.querySelector("#variant-main-select")[index].getAttribute("data-coming-soon") === "true" ? true : false;

        CustomSelects.forEach(select => {
          const index = parseInt(select.getAttribute("data-v-index"));
          const variantSize = parseInt(document.querySelector(".options-list").getAttribute("data-size"));
          let matchingName = activeOption.getAttribute("data-title");

          // If more than 1 variant, split by /
          if (variantSize > 1) {
            matchingName = matchingName.split(" / ")[index];
          }

          const active = select._skCustom.active;

          // Update low stock
          if (activeOption.getAttribute("data-low-stock") === "true" && multiVariantsExist === false) {
            active.classList.add("low-stock");
          } else {
            active.classList.remove("low-stock");
          }

          // Update sold out
          if (activeOption.getAttribute("data-available") === "false" && multiVariantsExist === false) {
            if (isComingSoon) {
              active.classList.remove("sold-out");
              active.classList.add("coming-soon");
            } else {
              active.classList.add("sold-out");
              active.classList.remove("coming-soon");
            }
          } else {
            active.classList.remove("sold-out");
            active.classList.remove("coming-soon");
          }

          // Update value
          active.setAttribute("data-val", matchingName);

          // Update text
          active.innerText = matchingName;
        });

        // Multi-variant sold out update
        if (multiVariantsExist) {
          // Get all options
          let allOptions = [];

          CustomSelects.forEach(sel => {
            let options = [];

            sel._skCustom.options.forEach(opt => {
              options.push(opt.getAttribute("data-val"));
            });

            allOptions.push(options);
          });

          // Go through each option and set its proper sold out state
          let currIndex = 0;

          CustomSelects.forEach(sel => {
            sel._skCustom.options.forEach(opt => {
              let soldOutCount = 0;
              let maxVariantCombinations = 0;

              // Calculate max variant combinations
              for (let i = 0; i < allOptions.length; i++) {
                if (i === currIndex) continue; // skip self from being multiplied in calculation

                if (maxVariantCombinations === 0) {
                  maxVariantCombinations = allOptions[i].length; // set first one
                } else {
                  maxVariantCombinations *= allOptions[i].length; // Multiply non-first
                }
              }

              // Go through every variant and check if this current option is sold out on every instance of itself
              Array.from(MainSelect.options).forEach(subOpt => {
                if (subOpt.getAttribute("data-title").split(" / ").find(splitTitle => opt.getAttribute("data-val") === splitTitle)) {
                  // Includes our current index variant -- check sold out?
                  const isAvailable = subOpt.getAttribute("data-available") === "true" ? true : false;

                  if (!isAvailable) {
                    soldOutCount++;
                  }
                }
              });

              // Mark this option as sold out completely
              if (soldOutCount === maxVariantCombinations) {
                if (isComingSoon) {
                  opt.classList.add("coming-soon");
                  opt.classList.remove("sold-out");
                } else {
                  opt.classList.remove("coming-soon");
                  opt.classList.add("sold-out");
                }
              } else {
                opt.classList.remove("sold-out");
                opt.classList.remove("coming-soon");
              }
            });

            currIndex++;
          });

          // Set active variants to proper sold out state
          CustomSelects.forEach(sel => {
            const activeOption = sel._skCustom.options.find(opt => opt.getAttribute("data-val") === sel._skCustom.active.getAttribute("data-val")); // Get sold out state

            if (!activeOption) {
              console.log("No active option could be found..");
            } else {
              if (activeOption.classList.contains("sold-out")) {
                sel._skCustom.active.classList.remove("coming-soon");
                sel._skCustom.active.classList.add("sold-out");
              } else if (activeOption.classList.contains("coming-soon")) {
                sel._skCustom.active.classList.add("coming-soon");
                sel._skCustom.active.classList.remove("sold-out");
              } else {
                sel._skCustom.active.classList.remove("sold-out");
                sel._skCustom.active.classList.remove("coming-soon");
              }
            }
          });
        }
      }

      // Handlers - Select
      /**
       * Select click handler (show options)
       */
      function selectClickHandler(e) {
        e.preventDefault();

        // Init
        const target = e.currentTarget;
        const parent = target.parentElement;

        // Get active dropdown
        const activeElem = document.querySelector(".options-list > .active");

        // Clear active dropdown
        if (activeElem) {
          activeElem.classList.remove("active");
        }

        // Set current as active dropdown
        parent.classList.add("active");

        // Focus selected
        parent.querySelector(`.custom-select-option[data-val='${parent._skCustom.active.getAttribute("data-val")}']`).focus();

        // Add body click off listener
        document.body.addEventListener("click", bodyClickHandler);
      }

      // Handlers - Options
      /**
       * Option click handler (option selected)
       * Doesn't update custom select itself, only updates main select, which then updates all selects appropriately
       */
      function optionClickHandler(e) {
        e.preventDefault();

        // Init
        const target = e.currentTarget;
        const topLevelParent = document.querySelector(`.custom-select-container.sk-desktop[data-v-index='${target.getAttribute("data-v-index")}']`);

        if (!topLevelParent) {
          if (DEBUG) {
            console.warn("Could not find top level parent");
          }

          return;
        }

        const active = topLevelParent._skCustom.active;

        // Remove current as active
        topLevelParent.classList.remove("active");

        // Set focus onto active select
        active.focus();

        // Remove body click off listener
        document.body.removeEventListener("click", bodyClickHandler);

        // Set main select active option to new active
        MainSelect._skCustom.setActiveByVIndexAndName({index: parseInt(target.getAttribute("data-v-index")), name: target.getAttribute("data-val")});
      }

      /**
       * Option keydown handler (up, down)
       */
      function optionKeydownHandler(e) {
        if (e.code === "ArrowUp" || e.code === "ArrowDown") {
          e.preventDefault();
        }

        // Init
        const target = e.currentTarget;
        const prev = target.parentElement.previousElementSibling;
        const next = target.parentElement.nextElementSibling;

        if (e.code === "ArrowUp") {
          // Focus next if found
          if (prev) {
            prev.firstElementChild.focus();
          }
        } else if (e.code === "ArrowDown") {
          // Focus next if found
          if (next) {
            next.firstElementChild.focus();
          }
        } else {
          return;
        }
      }

      // Window
      /**
       * Resize window handler
       */
      function resizeHandler() {
        hideAllSelects();
      }

      /**
       * Document click handler (hide options)
       */
      function bodyClickHandler(e) {
        const target = e.target;

        if (target.classList.contains("custom-select-active") ||
            target.classList.contains("custom-select-option") ||
            target.classList.contains("custom-select-list") ||
            target.classList.contains("custom-select")) {
          if (DEBUG) {
            console.warn("Option was clicked");
          }

          return;
        }

        hideAllSelects();
      }

      return init();
    }

    /**
     * Mobile Select Object
     */
    let CreateMobileSelects = () => {
      const MobileSelects = Array.from(document.querySelectorAll(".custom-select-container.sk-mobile"));

      // Init
      function init() {
        MobileSelects.forEach(mobileSelect => {
          const select = mobileSelect.querySelector(".custom-select");
          select.addEventListener("change", changeHandler);

          mobileSelect._skCustom = Object.freeze({
            select,
          });

          // Set low stock and sold out states IF only one option type
          if (MobileSelects.length === 1) {
            Array.from(select.options).forEach(option => {
              let available = false;
              let lowstock = false;

              let variant = document.querySelector(`.main-variant-select option[data-title="${option.getAttribute("data-val")}"]`);

              available = variant.getAttribute("data-available") === "true";
              lowstock = variant.getAttribute("data-low-stock") === "true";

              // if (!available) {
              //   option.innerText = `${option.innerText} / Sold Out`;
              // } else if (lowstock) {
              //   option.innerText = `${option.innerText} / Low Stock`;
              // }
            });
          }
        });

        // Events
        MainSelect.addEventListener("change", updateAllToMainSelect);

        return MobileSelects;
      }

      // Update
      /**
       * Update All to Main Select
       * This syncs all mobile selects to main select
       */
      function updateAllToMainSelect(e) {
        const activeOption = MainSelect._skCustom.getActiveOption();

        // Get coming soon
        let index = document.querySelector("#variant-main-select").selectedIndex;
        if (index < 0) index = 0;
        const isComingSoon = document.querySelector("#variant-main-select")[index].getAttribute("data-coming-soon") === "true" ? true : false;

        MobileSelects.forEach(mobileSelect => {
          const index = parseInt(mobileSelect.getAttribute("data-v-index"));
          const variantSize = parseInt(document.querySelector(".options-list").getAttribute("data-size"));
          let matchingName = activeOption.getAttribute("data-title");

          // If more than 1 variant, split by /
          if (variantSize > 1) {
            matchingName = matchingName.split(" / ")[index];
          }

          const matchingOption = Array.from(mobileSelect._skCustom.select.options).find(option => option.getAttribute("data-val") === matchingName);

          if (!matchingOption) {
            if (DEBUG) {
              console.warn("Matching variant not found");
            }

            return;
          }

          mobileSelect._skCustom.select.selectedIndex = matchingOption.index;
        });

        // Multi-variant sold out update
        if (multiVariantsExist) {
          // Get all options
          let allOptions = [];

          MobileSelects.forEach(selContainer => {
            const sel = selContainer.querySelector("select.custom-select");
            let options = [];

            Array.from(sel.options).forEach(opt => {
              options.push(opt.getAttribute("data-val"));
            });

            allOptions.push(options);
          });

          // Go through each option and set its proper sold out state
          let currIndex = 0;

          MobileSelects.forEach(selContainer => {
            const sel = selContainer.querySelector("select.custom-select");

            Array.from(sel.options).forEach(opt => {
              let soldOutCount = 0;
              let maxVariantCombinations = 0;

              // Calculate max variant combinations
              for (let i = 0; i < allOptions.length; i++) {
                if (i === currIndex) continue; // skip self from being multiplied in calculation

                if (maxVariantCombinations === 0) {
                  maxVariantCombinations = allOptions[i].length; // set first one
                } else {
                  maxVariantCombinations *= allOptions[i].length; // Multiply non-first
                }
              }

              // Go through every variant and check if this current option is sold out on every instance of itself
              Array.from(MainSelect.options).forEach(subOpt => {
                if (subOpt.getAttribute("data-title").split(" / ").find(splitTitle => opt.getAttribute("data-val") === splitTitle)) {
                  // Includes our current index variant -- check sold out?
                  const isAvailable = subOpt.getAttribute("data-available") === "true" ? true : false;

                  if (!isAvailable) {
                    soldOutCount++;
                  }
                }
              });

              // Mark this option as sold out completely
              if (soldOutCount === maxVariantCombinations) {
                if (isComingSoon) {
                  opt.innerText = `${opt.getAttribute("data-val")} / Coming Soon!`;
                } else {
                  opt.innerText = `${opt.getAttribute("data-val")} / Sold Out`;
                }
              } else {
                opt.innerText = `${opt.getAttribute("data-val")}`;
              }
            });

            currIndex++;
          });
        }
      }

      // Handlers
      function changeHandler(e) {
        const select = e.currentTarget;

        const variantName = select.options[select.selectedIndex].getAttribute("data-val");
        const variantIndex = parseInt(select.options[select.selectedIndex].getAttribute("data-v-index"));

        MainSelect._skCustom.setActiveByVIndexAndName({index: variantIndex, name: variantName});
      }

      return init();
    }

    return Object.freeze({
      init,
    });
  })();

  /*
    ====================
    Wishlist Manager
    ====================
  */
  const WishlistManager = (() => {
    // Timeouts
    let wishlistCountGenTimeout = undefined;
    let wishlistCountElem = document.querySelector(".wishlist__count");

    /*
      Set Functions
    */
    /**
     * Sets wishlist count using swym api
     *
     * Input:
     * - Product object
     */
    function SetWishlistCount(product = {}) {
      if (wishlistCountGenTimeout) {
        clearTimeout(wishlistCountGenTimeout);
      }

      // Look for swym object
      try {
        let url = GenWishlistCountReqUrl(product);

        fetch(url).then(res => res.json()).then(res => {
          console.log(res);

          // Populate wishlist count
          let wishlistCount = res.data.count;
          wishlistCountElem.innerText = wishlistCount;

          // Set wishlist state
          SetWishlistState();
        })
        .catch(res => {
          console.log("Could not get wishlist count", res);
        });
      } catch (err) {
        // Keep looking for swym
        wishlistCountGenTimeout = setTimeout(() => {
          SetWishlistCount(product);
        }, 500);
      }
    }

    /**
     * Sets wishlist state
     *
     * Input:
     * - Product object
     * https://swym.it/help/quick-start-guide-with-wishlist-plus-apis-for-shopify/
     */
    function SetWishlistState(variantId = 0) {
      function swymCallbackFn(){
        _swat.fetchWrtEventTypeET(fetchCallbackFn, 4);
        // fetching all wishlist events
      }

      function fetchCallbackFn(products){
        let activeProductId = SwymPageData.empi;
        let activeVariantId = SwymPageData.epi;

        if (variantId !== 0) {
          activeVariantId = variantId;
        }

        console.log(">>" + activeProductId + " | " + activeVariantId);
        products.forEach(p => console.log(p));
        let isInWishlist = products.find(function(p){
          return p.epi == activeVariantId && p.empi == activeProductId;
        });

        if(isInWishlist){
          document.querySelector(".product-main-content .wishlist-btn").classList.add("swym-added");
        } else {
          document.querySelector(".product-main-content .wishlist-btn").classList.remove("swym-added");
        }
      }

      if(!window.SwymCallbacks){
       window.SwymCallbacks = [];
      }

      window.SwymCallbacks.push(swymCallbackFn);
    }

    /*
      Generate Functions
    */
    function GenWishlistCountReqUrl(product = {}) {
      let url = "https://swymstore-v3premium-01.swymrelay.com/api/v3/product/social-count";

      // Get resources for url
      let du = `${document.body.getAttribute("data-url")}${product.url}`;
      let pid = _swat.get(_swat.key.PID);
      let empi = product.id;
      let topic = "addToWishlist";
      let regid = _swat.get(_swat.key.REGID);
      let sessionid = _swat.session.sessionId;

      // Create url
      url = `${url}?du=${du}`;
      url = `${url}&pid=${pid}`;
      url = `${url}&empi=${empi}`;
      url = `${url}&topic=${topic}`;
      url = `${url}&regid=${regid}`;
      url = `${url}&sessionid=${sessionid}`;

      return url;
    }

    return Object.freeze({
      SetWishlistCount,
      SetWishlistState,
    });
  })();

  return Object.freeze({
    Init,
  });
})();

/* Scroll Past Sliver Banner */
const ScrollPastSliverBanner = (() => {
  const largeScreenMediaRule = "only screen and (min-width: 768px)";

  /* Init */
  function init() {
    // If desktop, don't scroll
    if (window.matchMedia(largeScreenMediaRule).matches) {
      return;
    }

    const productMain = document.querySelector(".product-main__section-root");
    const header = document.querySelector(".header-root");
    let breadcrumbsHeight = 31;

    window.scrollTo({
      top: productMain.offsetTop - header.getBoundingClientRect().height + breadcrumbsHeight,
      left: 0,
      behavior: "smooth"
    });
  }

  return Object.freeze({
    init,
  });
})();

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".product-main-content").hasAttribute("data-product-url")) {
      ProductPage = ProductPage.Init(document.querySelector(".product-main-content").getAttribute("data-product-url"));
    }

    ScrollPastSliverBanner.init();
  });
} else {
  if (document.querySelector(".product-main-content").hasAttribute("data-product-url")) {
    ProductPage = ProductPage.Init(document.querySelector(".product-main-content").getAttribute("data-product-url"));
  }

  ScrollPastSliverBanner.init();
}

/* Breadcrumb init */
function initBreadcrumb() {
  let breadcrumbElem = document.querySelector(".global-breadcrumbs .breadcrumb-list");
  let breadcrumbHtml = sessionStorage.getItem("coll-breadcrumb");

  if (breadcrumbHtml) {
    breadcrumbElem.innerHTML = breadcrumbHtml;
    sessionStorage.removeItem("coll-breadcrumb");
  }

  breadcrumbElem.parentElement.classList.remove("sk-hidden");
}

initBreadcrumb();

// Quick Pay Init
const QuickPay = (() => {
  // Cart
  let cartCount = 0;

  // Buttons
  let pseudoPayHtml = `
    <div data-shopify="payment-button" data-has-selling-plan="false" data-has-fixed-selling-plan="false" class="shopify-payment-button" style="display: none;">
      <div style="display: none;">
        <div>
          <div>
            <div class="shopify-cleanslate">
              <div id="shopify-svg-symbols" class="R9tDu8JrE_i1ctOEo0v_" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" xmlnsxlink="http://www.w3.org/1999/xlink" focusable="false"><defs><symbol id="shopify-svg__warning" viewBox="0 0 16 14"><path d="M5.925 2.344c1.146-1.889 3.002-1.893 4.149 0l4.994 8.235c1.146 1.889.288 3.421-1.916 3.421h-10.305c-2.204 0-3.063-1.529-1.916-3.421l4.994-8.235zm1.075 1.656v5h2v-5h-2zm0 6v2h2v-2h-2z"></path></symbol><symbol id="shopify-svg__loading" viewBox="0 0 32 32"><path d="M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0v2C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14h2z"></path></symbol><symbol id="shopify-svg__error" viewBox="0 0 18 18"><path d="M9 18c5 0 9-4 9-9s-4-9-9-9-9 4-9 9 4 9 9 9z" style="fill: rgb(255, 62, 62);"></path><path d="M8 4h2v6H8z" style="fill: rgb(255, 255, 255);"></path><rect x="7.8" y="12" width="2.5" height="2.5" rx="1.3" style="fill: rgb(255, 255, 255);"></rect></symbol><symbol id="shopify-svg__close-circle" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8"></circle><path d="M10.5 5.5l-5 5M5.5 5.5l5 5" stroke="#FFF" stroke-width="1.5" stroke-linecap="square"></path></symbol><symbol id="shopify-svg__close" viewBox="0 0 20 20"><path d="M17.1 4.3l-1.4-1.4-5.7 5.7-5.7-5.7-1.4 1.4 5.7 5.7-5.7 5.7 1.4 1.4 5.7-5.7 5.7 5.7 1.4-1.4-5.7-5.7z"></path></symbol><symbol id="shopify-svg__arrow-right" viewBox="0 0 16 16"><path d="M16 8.1l-8.1 8.1-1.1-1.1L13 8.9H0V7.3h13L6.8 1.1 7.9 0 16 8.1z"></path></symbol><symbol id="shopify-svg__payments-google-pay-light" viewBox="0 0 41 17"><path d="M19.526 2.635v4.083h2.518c.6 0 1.096-.202 1.488-.605.403-.402.605-.882.605-1.437 0-.544-.202-1.018-.605-1.422-.392-.413-.888-.62-1.488-.62h-2.518zm0 5.52v4.736h-1.504V1.198h3.99c1.013 0 1.873.337 2.582 1.012.72.675 1.08 1.497 1.08 2.466 0 .991-.36 1.819-1.08 2.482-.697.665-1.559.996-2.583.996h-2.485v.001zM27.194 10.442c0 .392.166.718.499.98.332.26.722.391 1.168.391.633 0 1.196-.234 1.692-.701.497-.469.744-1.019.744-1.65-.469-.37-1.123-.555-1.962-.555-.61 0-1.12.148-1.528.442-.409.294-.613.657-.613 1.093m1.946-5.815c1.112 0 1.989.297 2.633.89.642.594.964 1.408.964 2.442v4.932h-1.439v-1.11h-.065c-.622.914-1.45 1.372-2.486 1.372-.882 0-1.621-.262-2.215-.784-.594-.523-.891-1.176-.891-1.96 0-.828.313-1.486.94-1.976s1.463-.735 2.51-.735c.892 0 1.629.163 2.206.49v-.344c0-.522-.207-.966-.621-1.33a2.132 2.132 0 0 0-1.455-.547c-.84 0-1.504.353-1.995 1.062l-1.324-.834c.73-1.045 1.81-1.568 3.238-1.568M40.993 4.889l-5.02 11.53H34.42l1.864-4.034-3.302-7.496h1.635l2.387 5.749h.032l2.322-5.75z" style="fill: rgb(255, 255, 255);"></path><path d="M13.448 7.134c0-.473-.04-.93-.116-1.366H6.988v2.588h3.634a3.11 3.11 0 0 1-1.344 2.042v1.68h2.169c1.27-1.17 2.001-2.9 2.001-4.944" style="fill: rgb(66, 133, 244);"></path><path d="M6.988 13.7c1.816 0 3.344-.595 4.459-1.621l-2.169-1.681c-.603.406-1.38.643-2.29.643-1.754 0-3.244-1.182-3.776-2.774H.978v1.731a6.728 6.728 0 0 0 6.01 3.703" style="fill: rgb(52, 168, 83);"></path><path d="M3.212 8.267a4.034 4.034 0 0 1 0-2.572V3.964H.978A6.678 6.678 0 0 0 .261 6.98c0 1.085.26 2.11.717 3.017l2.234-1.731z" style="fill: rgb(251, 188, 5);"></path><path d="M6.988 2.921c.992 0 1.88.34 2.58 1.008v.001l1.92-1.918C10.324.928 8.804.262 6.989.262a6.728 6.728 0 0 0-6.01 3.702l2.234 1.731c.532-1.592 2.022-2.774 3.776-2.774" style="fill: rgb(234, 67, 53);"></path></symbol><symbol id="shopify-svg__payments-google-pay-dark" viewBox="0 0 41 17"><path d="M19.526 2.635v4.083h2.518c.6 0 1.096-.202 1.488-.605.403-.402.605-.882.605-1.437 0-.544-.202-1.018-.605-1.422-.392-.413-.888-.62-1.488-.62h-2.518zm0 5.52v4.736h-1.504V1.198h3.99c1.013 0 1.873.337 2.582 1.012.72.675 1.08 1.497 1.08 2.466 0 .991-.36 1.819-1.08 2.482-.697.665-1.559.996-2.583.996h-2.485v.001zM27.194 10.442c0 .392.166.718.499.98.332.26.722.391 1.168.391.633 0 1.196-.234 1.692-.701.497-.469.744-1.019.744-1.65-.469-.37-1.123-.555-1.962-.555-.61 0-1.12.148-1.528.442-.409.294-.613.657-.613 1.093m1.946-5.815c1.112 0 1.989.297 2.633.89.642.594.964 1.408.964 2.442v4.932h-1.439v-1.11h-.065c-.622.914-1.45 1.372-2.486 1.372-.882 0-1.621-.262-2.215-.784-.594-.523-.891-1.176-.891-1.96 0-.828.313-1.486.94-1.976s1.463-.735 2.51-.735c.892 0 1.629.163 2.206.49v-.344c0-.522-.207-.966-.621-1.33a2.132 2.132 0 0 0-1.455-.547c-.84 0-1.504.353-1.995 1.062l-1.324-.834c.73-1.045 1.81-1.568 3.238-1.568M40.993 4.889l-5.02 11.53H34.42l1.864-4.034-3.302-7.496h1.635l2.387 5.749h.032l2.322-5.75z" style="fill: rgba(0, 0, 0, 0.55);"></path><path d="M13.448 7.134c0-.473-.04-.93-.116-1.366H6.988v2.588h3.634a3.11 3.11 0 0 1-1.344 2.042v1.68h2.169c1.27-1.17 2.001-2.9 2.001-4.944" style="fill: rgb(66, 133, 244);"></path><path d="M6.988 13.7c1.816 0 3.344-.595 4.459-1.621l-2.169-1.681c-.603.406-1.38.643-2.29.643-1.754 0-3.244-1.182-3.776-2.774H.978v1.731a6.728 6.728 0 0 0 6.01 3.703" style="fill: rgb(52, 168, 83);"></path><path d="M3.212 8.267a4.034 4.034 0 0 1 0-2.572V3.964H.978A6.678 6.678 0 0 0 .261 6.98c0 1.085.26 2.11.717 3.017l2.234-1.731z" style="fill: rgb(251, 188, 5);"></path><path d="M6.988 2.921c.992 0 1.88.34 2.58 1.008v.001l1.92-1.918C10.324.928 8.804.262 6.989.262a6.728 6.728 0 0 0-6.01 3.702l2.234 1.731c.532-1.592 2.022-2.774 3.776-2.774" style="fill: rgb(234, 67, 53);"></path></symbol><symbol id="shopify-svg__payments-facebook-pay-dark" viewBox="0 0 300 50"><path d="M277.374 25.35a330.858 330.858 0 0 1-5.496-14.28h6.355c1.122 3.701 2.393 7.365 3.739 11.066 1.383 3.7 2.803 7.364 4.336 10.953a271.222 271.222 0 0 0 7.29-22.019h6.131a183.26 183.26 0 0 1-2.692 7.963 500.958 500.958 0 0 1-3.402 9.159c-1.271 3.29-2.766 6.99-4.411 11.028-1.57 3.813-3.327 6.542-5.196 8.224-1.907 1.645-4.225 2.505-7.028 2.505a11.37 11.37 0 0 1-2.243-.225v-5.046c.374.037.673.074.897.112h.673c1.645 0 3.028-.449 4.149-1.309 1.122-.86 2.131-2.28 3.066-4.299-2.168-4.523-4.187-9.121-6.131-13.832h-.037Zm-9.795 13.421h-5.682v-3.888c-1.009 1.458-2.28 2.58-3.85 3.365-1.571.785-3.328 1.196-5.309 1.196-2.467 0-4.635-.636-6.505-1.87-1.906-1.233-3.364-2.99-4.448-5.158-1.084-2.206-1.608-4.71-1.608-7.514 0-2.804.561-5.346 1.645-7.552 1.084-2.168 2.617-3.887 4.561-5.121 1.944-1.234 4.187-1.87 6.692-1.87 1.906 0 3.588.375 5.121 1.122 1.495.748 2.766 1.795 3.738 3.14v-3.55h5.683v27.775l-.038-.075Zm-5.794-18.056c-.636-1.57-1.608-2.841-2.953-3.738-1.346-.898-2.879-1.384-4.636-1.384-2.467 0-4.449.823-5.944 2.505-1.458 1.682-2.205 3.925-2.205 6.767 0 2.84.71 5.121 2.13 6.803 1.421 1.682 3.327 2.505 5.795 2.505 1.794 0 3.402-.449 4.785-1.383 1.383-.935 2.43-2.168 3.028-3.739v-8.336ZM209 1.5h14.131c4.747 0 8.411 1.084 10.99 3.252 2.58 2.169 3.888 5.234 3.888 9.271 0 4.038-1.271 7.103-3.85 9.271-2.58 2.169-6.243 3.253-11.028 3.253h-8.038v12.261H209V1.5Zm13.645 19.551c3.14 0 5.42-.56 6.916-1.72 1.495-1.158 2.243-2.915 2.243-5.27 0-2.355-.748-4.225-2.243-5.346-1.496-1.122-3.813-1.72-6.916-1.72h-7.552v14.056h7.552ZM71.937 1.249h7.429l12.63 22.85 12.632-22.85h7.268v37.546h-6.06V10.019L94.758 29.946h-5.686L77.997 10.019v28.776h-6.06V1.249Zm58.947 13.999c-4.346 0-6.964 3.27-7.59 7.32h14.75c-.304-4.171-2.711-7.32-7.16-7.32Zm-13.598 9.628c0-8.522 5.508-14.725 13.703-14.725 8.061 0 12.875 6.124 12.875 15.18v1.665h-20.57c.73 4.405 3.653 7.374 8.367 7.374 3.761 0 6.112-1.147 8.34-3.246l3.22 3.943c-3.033 2.79-6.891 4.398-11.775 4.398-8.872 0-14.16-6.47-14.16-14.589Zm33.926-9.09h-5.579v-4.963h5.579V2.618h5.846v8.205h8.475v4.962h-8.475v12.577c0 4.294 1.373 5.82 4.747 5.82 1.541 0 2.424-.132 3.728-.35v4.909c-1.625.459-3.176.67-4.854.67-6.312 0-9.467-3.449-9.467-10.352V15.785v.001Zm38.941 4.825c-1.174-2.965-3.794-5.148-7.644-5.148-5.003 0-8.205 3.55-8.205 9.333 0 5.638 2.948 9.36 7.966 9.36 3.944 0 6.76-2.296 7.883-5.15V20.61v.001ZM196 38.795h-5.739v-3.916c-1.605 2.305-4.524 4.586-9.253 4.586-7.604 0-12.686-6.366-12.686-14.67 0-8.381 5.204-14.644 13.009-14.644 3.858 0 6.885 1.543 8.93 4.266v-3.594H196v27.972Z" fill="#000000"></path><path d="M6.422 26.042c0 2.27.498 4.013 1.15 5.068.853 1.38 2.127 1.966 3.425 1.966 1.675 0 3.207-.415 6.16-4.499 2.364-3.273 5.151-7.867 7.027-10.747l3.175-4.88c2.206-3.388 4.76-7.155 7.687-9.708C37.436 1.158 40.015 0 42.61 0c4.357 0 8.506 2.524 11.682 7.259 3.475 5.185 5.162 11.717 5.162 18.457 0 4.007-.79 6.95-2.133 9.277-1.299 2.25-3.83 4.497-8.086 4.497v-6.414c3.645 0 4.554-3.35 4.554-7.182 0-5.463-1.273-11.525-4.079-15.856-1.99-3.073-4.571-4.95-7.41-4.95-3.07 0-5.54 2.316-8.317 6.445-1.477 2.193-2.992 4.867-4.694 7.883l-1.873 3.318c-3.763 6.672-4.716 8.192-6.597 10.7-3.298 4.391-6.114 6.056-9.82 6.056-4.398 0-7.18-1.905-8.901-4.774C.69 32.377 0 29.309 0 25.813l6.422.23v-.001Z" fill="#0081FB"></path><path d="M5.063 7.712C8.007 3.174 12.256 0 17.13 0c2.823 0 5.628.835 8.558 3.227 3.204 2.616 6.62 6.922 10.881 14.02l1.528 2.547c3.688 6.145 5.787 9.306 7.015 10.797 1.58 1.914 2.686 2.485 4.123 2.485 3.645 0 4.554-3.35 4.554-7.182l5.665-.178c0 4.007-.79 6.95-2.133 9.277-1.299 2.25-3.83 4.496-8.086 4.496-2.647 0-4.991-.574-7.584-3.02-1.993-1.877-4.323-5.212-6.116-8.21l-5.332-8.907c-2.675-4.47-5.13-7.803-6.55-9.312-1.528-1.623-3.492-3.583-6.626-3.583-2.537 0-4.691 1.78-6.494 4.503L5.064 7.712h-.001Z" fill="url(#meta-pay-button__a)"></path><path d="M17.026 6.457c-2.537 0-4.691 1.78-6.494 4.503-2.55 3.848-4.11 9.579-4.11 15.082 0 2.27.498 4.013 1.15 5.068l-5.476 3.606C.691 32.377 0 29.309 0 25.813c0-6.358 1.745-12.984 5.063-18.101C8.007 3.174 12.256 0 17.13 0l-.103 6.457h-.001Z" fill="url(#meta-pay-button__b)"></path><defs><linearGradient id="meta-pay-button__a" x1="12.612" y1="24.19" x2="53.549" y2="26.257" gradientUnits="userSpaceOnUse"><stop stop-color="#0064E1"></stop><stop offset=".4" stop-color="#0064E1"></stop><stop offset=".83" stop-color="#0073EE"></stop><stop offset="1" stop-color="#0082FB"></stop></linearGradient><linearGradient id="meta-pay-button__b" x1="9.304" y1="28.738" x2="9.304" y2="13.646" gradientUnits="userSpaceOnUse"><stop stop-color="#0082FB"></stop><stop offset="1" stop-color="#0064E0"></stop></linearGradient></defs></symbol><symbol id="shopify-svg__payments-facebook-pay-light" viewBox="0 0 300 50"><path d="M277.374 25.35a330.858 330.858 0 0 1-5.496-14.28h6.355c1.122 3.701 2.393 7.365 3.739 11.066 1.383 3.7 2.803 7.364 4.336 10.953a271.222 271.222 0 0 0 7.29-22.019h6.131a183.26 183.26 0 0 1-2.692 7.963 500.958 500.958 0 0 1-3.402 9.159c-1.271 3.29-2.766 6.99-4.411 11.028-1.57 3.813-3.327 6.542-5.196 8.224-1.907 1.645-4.225 2.505-7.028 2.505a11.37 11.37 0 0 1-2.243-.225v-5.046c.374.037.673.074.897.112h.673c1.645 0 3.028-.449 4.149-1.309 1.122-.86 2.131-2.28 3.066-4.299-2.168-4.523-4.187-9.121-6.131-13.832h-.037Zm-9.795 13.421h-5.682v-3.888c-1.009 1.458-2.28 2.58-3.85 3.365-1.571.785-3.328 1.196-5.309 1.196-2.467 0-4.635-.636-6.505-1.87-1.906-1.233-3.364-2.99-4.448-5.158-1.084-2.206-1.608-4.71-1.608-7.514 0-2.804.561-5.346 1.645-7.552 1.084-2.168 2.617-3.887 4.561-5.121 1.944-1.234 4.187-1.87 6.692-1.87 1.906 0 3.588.375 5.121 1.122 1.495.748 2.766 1.795 3.738 3.14v-3.55h5.683v27.775l-.038-.075Zm-5.794-18.056c-.636-1.57-1.608-2.841-2.953-3.738-1.346-.898-2.879-1.384-4.636-1.384-2.467 0-4.449.823-5.944 2.505-1.458 1.682-2.205 3.925-2.205 6.767 0 2.84.71 5.121 2.13 6.803 1.421 1.682 3.327 2.505 5.795 2.505 1.794 0 3.402-.449 4.785-1.383 1.383-.935 2.43-2.168 3.028-3.739v-8.336ZM209 1.5h14.131c4.747 0 8.411 1.084 10.99 3.252 2.58 2.169 3.888 5.234 3.888 9.271 0 4.038-1.271 7.103-3.85 9.271-2.58 2.169-6.243 3.253-11.028 3.253h-8.038v12.261H209V1.5Zm13.645 19.551c3.14 0 5.42-.56 6.916-1.72 1.495-1.158 2.243-2.915 2.243-5.27 0-2.355-.748-4.225-2.243-5.346-1.496-1.122-3.813-1.72-6.916-1.72h-7.552v14.056h7.552ZM71.937 1.249h7.429l12.63 22.85 12.632-22.85h7.268v37.546h-6.06V10.019L94.758 29.946h-5.686L77.997 10.019v28.776h-6.06V1.249Zm58.947 13.999c-4.346 0-6.964 3.27-7.59 7.32h14.75c-.304-4.171-2.711-7.32-7.16-7.32Zm-13.598 9.628c0-8.522 5.508-14.725 13.703-14.725 8.061 0 12.875 6.124 12.875 15.18v1.665h-20.57c.73 4.405 3.653 7.374 8.367 7.374 3.761 0 6.112-1.147 8.34-3.246l3.22 3.943c-3.033 2.79-6.891 4.398-11.775 4.398-8.872 0-14.16-6.47-14.16-14.589Zm33.926-9.09h-5.579v-4.963h5.579V2.618h5.846v8.205h8.475v4.962h-8.475v12.577c0 4.294 1.373 5.82 4.747 5.82 1.541 0 2.424-.132 3.728-.35v4.909c-1.625.459-3.176.67-4.854.67-6.312 0-9.467-3.449-9.467-10.352V15.785v.001Zm38.941 4.825c-1.174-2.965-3.794-5.148-7.644-5.148-5.003 0-8.205 3.55-8.205 9.333 0 5.638 2.948 9.36 7.966 9.36 3.944 0 6.76-2.296 7.883-5.15V20.61v.001ZM196 38.795h-5.739v-3.916c-1.605 2.305-4.524 4.586-9.253 4.586-7.604 0-12.686-6.366-12.686-14.67 0-8.381 5.204-14.644 13.009-14.644 3.858 0 6.885 1.543 8.93 4.266v-3.594H196v27.972Z" fill="#fff"></path><path d="M6.422 26.042c0 2.27.498 4.013 1.15 5.068.853 1.38 2.127 1.966 3.425 1.966 1.675 0 3.207-.415 6.16-4.499 2.364-3.273 5.151-7.867 7.027-10.747l3.175-4.88c2.206-3.388 4.76-7.155 7.687-9.708C37.436 1.158 40.015 0 42.61 0c4.357 0 8.506 2.524 11.682 7.259 3.475 5.185 5.162 11.717 5.162 18.457 0 4.007-.79 6.95-2.133 9.277-1.299 2.25-3.83 4.497-8.086 4.497v-6.414c3.645 0 4.554-3.35 4.554-7.182 0-5.463-1.273-11.525-4.079-15.856-1.99-3.073-4.571-4.95-7.41-4.95-3.07 0-5.54 2.316-8.317 6.445-1.477 2.193-2.992 4.867-4.694 7.883l-1.873 3.318c-3.763 6.672-4.716 8.192-6.597 10.7-3.298 4.391-6.114 6.056-9.82 6.056-4.398 0-7.18-1.905-8.901-4.774C.69 32.377 0 29.309 0 25.813l6.422.23v-.001Z" fill="#0081FB"></path><path d="M5.063 7.712C8.007 3.174 12.256 0 17.13 0c2.823 0 5.628.835 8.558 3.227 3.204 2.616 6.62 6.922 10.881 14.02l1.528 2.547c3.688 6.145 5.787 9.306 7.015 10.797 1.58 1.914 2.686 2.485 4.123 2.485 3.645 0 4.554-3.35 4.554-7.182l5.665-.178c0 4.007-.79 6.95-2.133 9.277-1.299 2.25-3.83 4.496-8.086 4.496-2.647 0-4.991-.574-7.584-3.02-1.993-1.877-4.323-5.212-6.116-8.21l-5.332-8.907c-2.675-4.47-5.13-7.803-6.55-9.312-1.528-1.623-3.492-3.583-6.626-3.583-2.537 0-4.691 1.78-6.494 4.503L5.064 7.712h-.001Z" fill="url(#meta-pay-button__a)"></path><path d="M17.026 6.457c-2.537 0-4.691 1.78-6.494 4.503-2.55 3.848-4.11 9.579-4.11 15.082 0 2.27.498 4.013 1.15 5.068l-5.476 3.606C.691 32.377 0 29.309 0 25.813c0-6.358 1.745-12.984 5.063-18.101C8.007 3.174 12.256 0 17.13 0l-.103 6.457h-.001Z" fill="url(#meta-pay-button__b)"></path><defs><linearGradient id="meta-pay-button__a" x1="12.612" y1="24.19" x2="53.549" y2="26.257" gradientUnits="userSpaceOnUse"><stop stop-color="#0064E1"></stop><stop offset=".4" stop-color="#0064E1"></stop><stop offset=".83" stop-color="#0073EE"></stop><stop offset="1" stop-color="#0082FB"></stop></linearGradient><linearGradient id="meta-pay-button__b" x1="9.304" y1="28.738" x2="9.304" y2="13.646" gradientUnits="userSpaceOnUse"><stop stop-color="#0082FB"></stop><stop offset="1" stop-color="#0064E0"></stop></linearGradient></defs></symbol><symbol id="shopify-svg__payments-amazon-pay" viewBox="0 0 102 20"><path d="M75.19 1.786c-.994 0-1.933.326-2.815.98v5.94c.896.683 1.82 1.023 2.774 1.023 1.932 0 2.899-1.32 2.899-3.96 0-2.655-.953-3.983-2.858-3.983zm-2.962-.277A5.885 5.885 0 0 1 73.93.444a4.926 4.926 0 0 1 1.85-.362c.672 0 1.282.127 1.827.383a3.763 3.763 0 0 1 1.387 1.108c.378.482.669 1.068.872 1.757.203.689.305 1.466.305 2.332 0 .88-.109 1.675-.326 2.385-.217.71-.522 1.314-.914 1.81a4.137 4.137 0 0 1-1.429 1.16 4.165 4.165 0 0 1-1.87.416c-1.26 0-2.346-.419-3.256-1.256v4.983c0 .284-.14.426-.42.426h-1.24c-.28 0-.42-.142-.42-.426V.827c0-.284.14-.426.42-.426h.925c.28 0 .441.142.483.426l.105.682zm13.194 8.37a4.21 4.21 0 0 0 1.45-.277 5.463 5.463 0 0 0 1.45-.81V6.62c-.35-.085-.719-.152-1.104-.202a8.8 8.8 0 0 0-1.124-.075c-1.583 0-2.374.617-2.374 1.853 0 .54.147.955.441 1.246.294.29.715.437 1.261.437zm-2.458-7.625l-.158.053a.561.561 0 0 1-.179.033c-.182 0-.273-.128-.273-.384V1.38c0-.199.028-.337.084-.415.056-.078.169-.153.337-.224.448-.199 1-.359 1.66-.48.657-.12 1.316-.18 1.974-.18 1.33 0 2.311.277 2.942.83.63.554.945 1.413.945 2.577v7.284c0 .284-.14.426-.42.426h-.903c-.267 0-.42-.135-.463-.405l-.105-.702a5.74 5.74 0 0 1-1.67 1.022 4.908 4.908 0 0 1-1.817.362c-1.009 0-1.807-.288-2.395-.863-.589-.575-.883-1.345-.883-2.31 0-1.037.364-1.864 1.092-2.481.73-.618 1.71-.927 2.942-.927.784 0 1.667.12 2.647.362V3.852c0-.767-.168-1.307-.504-1.619-.336-.313-.925-.469-1.764-.469-.982 0-2.01.163-3.09.49zm14.16 10.84c-.379.98-.816 1.683-1.314 2.109-.496.426-1.144.639-1.943.639-.448 0-.847-.05-1.197-.15a.606.606 0 0 1-.336-.202c-.07-.093-.105-.237-.105-.437V14.5c0-.27.105-.405.315-.405.07 0 .175.014.315.043.14.028.33.043.567.043.532 0 .946-.128 1.24-.384.294-.255.56-.724.798-1.406l.4-1.086-4.056-10.137c-.098-.241-.146-.411-.146-.511 0-.17.097-.256.294-.256h1.26c.224 0 .378.036.463.106.083.072.167.228.251.47l2.942 8.263L99.708.976c.084-.24.168-.397.252-.469.084-.07.238-.106.462-.106h1.177c.196 0 .294.086.294.256 0 .1-.05.27-.147.51l-4.622 11.927M40.15 15.47c-3.761 2.814-9.216 4.31-13.912 4.31-6.583 0-12.51-2.466-16.996-6.572-.352-.322-.038-.763.385-.513 4.84 2.855 10.825 4.574 17.006 4.574 4.17 0 8.753-.877 12.971-2.691.636-.273 1.17.425.547.891" style="fill: rgb(51, 62, 72);"></path><path d="M41.717 13.657c-.482-.624-3.181-.296-4.394-.148-.368.044-.425-.281-.093-.517 2.153-1.533 5.682-1.09 6.092-.577.413.518-.108 4.104-2.127 5.816-.31.263-.605.122-.468-.225.455-1.15 1.471-3.724.99-4.349M37.429 2.06V.57A.365.365 0 0 1 37.8.193l6.59-.001c.21 0 .38.155.38.376v1.278c-.003.214-.18.494-.496.938L40.86 7.722c1.267-.03 2.607.163 3.757.818.26.148.33.367.35.582v1.59c0 .218-.237.472-.485.34-2.028-1.077-4.718-1.194-6.96.013-.23.124-.47-.126-.47-.345V9.209c0-.242.005-.656.246-1.024l3.953-5.75H37.81a.369.369 0 0 1-.38-.375M13.4 11.365h-2.005a.38.38 0 0 1-.358-.343L11.038.595a.38.38 0 0 1 .387-.375h1.866a.38.38 0 0 1 .365.35v1.36h.037C14.18.615 15.096 0 16.331 0c1.253 0 2.039.614 2.6 1.93C19.418.615 20.521 0 21.7 0c.842 0 1.758.351 2.32 1.141.635.878.505 2.15.505 3.27l-.002 6.58a.38.38 0 0 1-.387.374h-2.001a.378.378 0 0 1-.36-.374V5.463c0-.438.037-1.535-.056-1.952-.15-.703-.6-.9-1.179-.9-.486 0-.991.33-1.197.855-.206.527-.188 1.405-.188 1.997v5.527a.38.38 0 0 1-.386.375h-2.002a.379.379 0 0 1-.36-.374l-.001-5.528c0-1.163.186-2.874-1.235-2.874-1.44 0-1.384 1.668-1.384 2.874l-.001 5.527a.38.38 0 0 1-.387.375m37.059-9.236c-1.478 0-1.571 2.04-1.571 3.312 0 1.273-.02 3.993 1.552 3.993 1.554 0 1.628-2.194 1.628-3.532 0-.877-.038-1.93-.3-2.764-.224-.724-.673-1.01-1.31-1.01zM50.439 0c2.975 0 4.584 2.59 4.584 5.88 0 3.181-1.777 5.705-4.584 5.705-2.918 0-4.508-2.59-4.508-5.814C45.93 2.523 47.539 0 50.439 0zm8.441 11.365h-1.997a.379.379 0 0 1-.36-.374L56.52.561a.381.381 0 0 1 .386-.34L58.764.22c.175.009.32.13.356.291v1.595h.038C59.72.68 60.505 0 61.89 0c.898 0 1.778.329 2.339 1.229.524.834.524 2.237.524 3.247v6.561a.382.382 0 0 1-.385.328H62.36a.38.38 0 0 1-.357-.328V5.376c0-1.141.13-2.809-1.253-2.809-.487 0-.936.33-1.16.834-.281.636-.319 1.272-.319 1.975v5.614a.386.386 0 0 1-.39.375m-24.684.075a.41.41 0 0 1-.473.047c-.665-.56-.785-.82-1.149-1.354-1.1 1.136-1.879 1.477-3.304 1.477-1.687 0-3-1.055-3-3.166 0-1.65.882-2.77 2.138-3.32 1.087-.484 2.606-.572 3.769-.704v-.264c0-.484.037-1.055-.245-1.473-.243-.374-.712-.528-1.124-.528-.765 0-1.444.397-1.611 1.22-.035.183-.167.364-.348.374l-1.943-.214c-.164-.037-.346-.17-.299-.425C27.055.721 29.183 0 31.09 0c.975 0 2.25.263 3.018 1.011.975.924.881 2.155.881 3.497v3.165c0 .952.39 1.37.757 1.882.128.185.156.405-.007.54-.409.348-1.136.988-1.537 1.35l-.005-.005zm-2.02-4.953v-.44c-1.45 0-2.98.314-2.98 2.045 0 .88.45 1.473 1.218 1.473.562 0 1.069-.352 1.387-.923.394-.704.376-1.363.376-2.155zM7.926 11.44a.41.41 0 0 1-.473.047c-.667-.56-.786-.82-1.15-1.354C5.204 11.27 4.425 11.61 3 11.61c-1.688 0-3-1.055-3-3.166 0-1.65.88-2.77 2.137-3.32 1.087-.484 2.606-.572 3.768-.704v-.264c0-.484.038-1.055-.243-1.473-.244-.374-.713-.528-1.125-.528-.764 0-1.444.397-1.61 1.22-.036.183-.168.364-.35.374l-1.94-.214c-.165-.037-.347-.17-.3-.425C.783.721 2.911 0 4.818 0c.975 0 2.25.263 3.018 1.011.975.924.882 2.155.882 3.497v3.165c0 .952.39 1.37.756 1.882.128.185.157.405-.006.54a78.47 78.47 0 0 0-1.537 1.35l-.005-.005zm-2.02-4.953v-.44c-1.45 0-2.982.314-2.982 2.045 0 .88.45 1.473 1.219 1.473.562 0 1.069-.352 1.387-.923.394-.704.375-1.363.375-2.155z" style="fill: rgb(51, 62, 72);"></path></symbol><symbol id="shopify-svg__payments-apple-pay-dark" viewBox="0 0 43 19"><path d="M6.948 1.409C7.934.147 9.305.147 9.305.147s.193 1.18-.771 2.316c-1.05 1.2-2.228.993-2.228.993s-.236-.93.642-2.047zM3.82 3.663c-1.735 0-3.6 1.51-3.6 4.363 0 2.916 2.186 6.555 3.943 6.555.6 0 1.543-.6 2.485-.6.922 0 1.607.559 2.464.559 1.907 0 3.322-3.826 3.322-3.826s-2.015-.744-2.015-2.936c0-1.944 1.629-2.73 1.629-2.73s-.836-1.447-2.936-1.447c-1.22 0-2.164.661-2.656.661-.622.021-1.5-.6-2.636-.6zM19.64 1.426c2.453 0 4.188 1.788 4.188 4.396 0 2.608-1.755 4.417-4.248 4.417h-2.932v4.564h-1.974V1.426h4.966zm-2.992 7.067h2.473c1.695 0 2.693-.967 2.693-2.65 0-1.683-.978-2.671-2.693-2.671h-2.473v5.321zm7.559 3.429c0-1.767 1.296-2.777 3.65-2.945l2.572-.147v-.78c0-1.156-.738-1.787-1.994-1.787-1.037 0-1.795.568-1.955 1.43h-1.775c.06-1.788 1.656-3.092 3.79-3.092 2.333 0 3.829 1.304 3.829 3.281v6.9h-1.815v-1.684h-.04c-.519 1.094-1.715 1.788-3.012 1.788-1.934.021-3.25-1.178-3.25-2.965zm6.222-.905v-.778l-2.313.168c-1.297.084-1.975.59-1.975 1.494 0 .862.718 1.409 1.815 1.409 1.396-.021 2.473-.968 2.473-2.293zm3.969 7.383v-1.64c.14.041.438.041.598.041.897 0 1.416-.4 1.735-1.472l.14-.526L33.4 4.707h2.054l2.453 8.224h.04L40.4 4.707h1.994l-3.57 10.538c-.818 2.419-1.715 3.197-3.67 3.197-.14.02-.598-.021-.757-.042z" style="fill: rgb(0, 0, 0);"></path></symbol><symbol id="shopify-svg__payments-apple-pay-light" viewBox="0 0 43 19"><path d="M6.948 1.409C7.934.147 9.305.147 9.305.147s.193 1.18-.771 2.316c-1.05 1.2-2.228.993-2.228.993s-.236-.93.642-2.047zM3.82 3.663c-1.735 0-3.6 1.51-3.6 4.363 0 2.916 2.186 6.555 3.943 6.555.6 0 1.543-.6 2.485-.6.922 0 1.607.559 2.464.559 1.907 0 3.322-3.826 3.322-3.826s-2.015-.744-2.015-2.936c0-1.944 1.629-2.73 1.629-2.73s-.836-1.447-2.936-1.447c-1.22 0-2.164.661-2.656.661-.622.021-1.5-.6-2.636-.6zM19.64 1.426c2.453 0 4.188 1.788 4.188 4.396 0 2.608-1.755 4.417-4.248 4.417h-2.932v4.564h-1.974V1.426h4.966zm-2.992 7.067h2.473c1.695 0 2.693-.967 2.693-2.65 0-1.683-.978-2.671-2.693-2.671h-2.473v5.321zm7.559 3.429c0-1.767 1.296-2.777 3.65-2.945l2.572-.147v-.78c0-1.156-.738-1.787-1.994-1.787-1.037 0-1.795.568-1.955 1.43h-1.775c.06-1.788 1.656-3.092 3.79-3.092 2.333 0 3.829 1.304 3.829 3.281v6.9h-1.815v-1.684h-.04c-.519 1.094-1.715 1.788-3.012 1.788-1.934.021-3.25-1.178-3.25-2.965zm6.222-.905v-.778l-2.313.168c-1.297.084-1.975.59-1.975 1.494 0 .862.718 1.409 1.815 1.409 1.396-.021 2.473-.968 2.473-2.293zm3.969 7.383v-1.64c.14.041.438.041.598.041.897 0 1.416-.4 1.735-1.472l.14-.526L33.4 4.707h2.054l2.453 8.224h.04L40.4 4.707h1.994l-3.57 10.538c-.818 2.419-1.715 3.197-3.67 3.197-.14.02-.598-.021-.757-.042z" style="fill: rgb(255, 255, 255);"></path></symbol><symbol id="shopify-svg__payments-paypal" viewBox="0 0 67 19"><path d="M8.44.57H3.29a.718.718 0 0 0-.707.61L.502 14.517c-.041.263.16.5.425.5h2.458a.718.718 0 0 0 .707-.61l.561-3.597a.717.717 0 0 1 .706-.611h1.63c3.391 0 5.349-1.658 5.86-4.944.23-1.437.01-2.566-.657-3.357C11.461 1.029 10.162.57 8.44.57zm.594 4.87C8.752 7.308 7.34 7.308 5.976 7.308h-.777l.545-3.485a.43.43 0 0 1 .424-.366h.356c.93 0 1.807 0 2.26.535.27.32.353.794.25 1.45zm14.796-.06h-2.466a.43.43 0 0 0-.424.367l-.109.696-.172-.252c-.534-.783-1.724-1.044-2.912-1.044-2.725 0-5.052 2.084-5.505 5.008-.235 1.46.1 2.854.919 3.827.75.894 1.826 1.267 3.105 1.267 2.195 0 3.412-1.426 3.412-1.426l-.11.692a.432.432 0 0 0 .424.502h2.22a.718.718 0 0 0 .707-.61l1.333-8.526a.43.43 0 0 0-.423-.5zm-3.437 4.849c-.238 1.422-1.356 2.378-2.782 2.378-.716 0-1.288-.232-1.655-.672-.365-.436-.503-1.058-.387-1.75.222-1.41 1.359-2.397 2.763-2.397.7 0 1.269.235 1.644.678.375.448.524 1.073.417 1.763zM36.96 5.38h-2.478a.716.716 0 0 0-.592.318l-3.417 5.085-1.448-4.887a.719.719 0 0 0-.687-.515h-2.435a.433.433 0 0 0-.407.573l2.73 8.09-2.567 3.66a.434.434 0 0 0 .35.684h2.475a.712.712 0 0 0 .588-.31l8.24-12.016a.434.434 0 0 0-.352-.681z" style="fill: rgb(37, 59, 128);"></path><path d="M45.163.57h-5.15a.717.717 0 0 0-.706.61l-2.082 13.337a.43.43 0 0 0 .423.5h2.642a.502.502 0 0 0 .494-.427l.591-3.78a.717.717 0 0 1 .706-.611h1.63c3.392 0 5.348-1.658 5.86-4.944.231-1.437.009-2.566-.657-3.357C48.183 1.029 46.886.57 45.163.57zm.593 4.87c-.28 1.867-1.692 1.867-3.057 1.867h-.777l.546-3.485a.429.429 0 0 1 .423-.366h.356c.93 0 1.807 0 2.26.535.27.32.353.794.25 1.45zm14.795-.06h-2.464a.428.428 0 0 0-.423.367l-.109.696-.173-.252c-.534-.783-1.723-1.044-2.911-1.044-2.724 0-5.05 2.084-5.504 5.008-.235 1.46.099 2.854.918 3.827.753.894 1.826 1.267 3.105 1.267 2.195 0 3.413-1.426 3.413-1.426l-.11.692a.432.432 0 0 0 .424.502h2.22a.717.717 0 0 0 .707-.61l1.333-8.526a.433.433 0 0 0-.426-.5zm-3.436 4.849c-.237 1.422-1.356 2.378-2.782 2.378-.714 0-1.288-.232-1.655-.672-.365-.436-.502-1.058-.387-1.75.223-1.41 1.359-2.397 2.763-2.397.7 0 1.269.235 1.644.678.377.448.526 1.073.417 1.763zM63.458.935l-2.113 13.582a.43.43 0 0 0 .423.5h2.124a.716.716 0 0 0 .707-.61L66.683 1.07a.432.432 0 0 0-.423-.5h-2.379c-.21 0-.39.156-.423.366z" style="fill: rgb(23, 155, 215);"></path></symbol><symbol id="shopify-svg__payments-shop-pay" viewBox="0 -2 341 81"><path fill-rule="evenodd" clip-rule="evenodd" d="M227.297 0C220.448 0 214.896 5.47237 214.896 12.2229V67.8125C214.896 74.563 220.448 80.0354 227.297 80.0354H328.357C335.206 80.0354 340.758 74.563 340.758 67.8125V12.2229C340.758 5.47237 335.206 0 328.357 0H227.297ZM244.999 55.8917V41.8012H253.993C262.21 41.8012 266.579 37.2604 266.579 30.379C266.579 23.4976 262.21 19.3782 253.993 19.3782H239.205V55.8917H244.999ZM244.999 24.8084H252.663C257.982 24.8084 260.595 26.9617 260.595 30.5663C260.595 34.1708 258.077 36.3242 252.9 36.3242H244.999V24.8084ZM276.795 56.6407C281.212 56.6407 284.109 54.7214 285.439 51.4445C285.819 55.0959 288.052 56.9684 292.896 55.7044L292.944 51.819C290.996 52.0063 290.616 51.3041 290.616 49.2912V39.7415C290.616 34.124 286.864 30.8003 279.93 30.8003C273.09 30.8003 269.148 34.1708 269.148 39.8819H274.468C274.468 37.1668 276.415 35.5284 279.835 35.5284C283.444 35.5284 285.107 37.0732 285.059 39.7415V40.9586L278.932 41.614C272.045 42.3629 268.246 44.9376 268.246 49.4316C268.246 53.1298 270.905 56.6407 276.795 56.6407ZM277.982 52.4276C274.99 52.4276 273.803 50.836 273.803 49.2443C273.803 47.091 276.273 46.1079 281.117 45.5462L284.917 45.1249C284.679 49.2443 281.877 52.4276 277.982 52.4276ZM310.537 57.7174C308.115 63.5221 304.22 65.2541 298.141 65.2541H295.528V60.4793H298.331C301.655 60.4793 303.27 59.4494 305.028 56.5002L294.246 31.5493H300.23L307.925 49.7593L314.764 31.5493H320.606L310.537 57.7174Z" fill="white"></path><path d="M29.5136 35.1798C21.5797 33.4835 18.0451 32.8197 18.0451 29.8064C18.0451 26.9722 20.4371 25.5604 25.221 25.5604C29.4282 25.5604 32.5036 27.3726 34.7674 30.9232C34.9382 31.1972 35.2906 31.292 35.5789 31.1445L44.506 26.6983C44.8263 26.5402 44.9438 26.1399 44.7623 25.8343C41.0569 19.5022 34.2121 16.0358 25.1996 16.0358C13.3574 16.0358 6 21.7885 6 30.9338C6 40.648 14.9591 43.1029 22.9038 44.7992C30.8484 46.4955 34.3936 47.1592 34.3936 50.1725C34.3936 53.1858 31.8095 54.6082 26.6518 54.6082C21.8893 54.6082 18.3548 52.4589 16.2191 48.2866C16.059 47.981 15.6852 47.8546 15.3756 48.0127L6.46985 52.364C6.16017 52.5221 6.03203 52.8908 6.19221 53.2069C9.72673 60.2134 16.9773 64.1538 26.6625 64.1538C38.996 64.1538 46.4494 58.496 46.4494 49.0663C46.4494 39.6365 37.4476 36.8972 29.5136 35.2009V35.1798Z" fill="white"></path><path d="M77.3525 16.0358C72.291 16.0358 67.8168 17.8059 64.6026 20.9561C64.3997 21.1458 64.0687 21.0088 64.0687 20.7349V0.621625C64.0687 0.273937 63.791 0 63.4387 0H52.2692C51.9168 0 51.6391 0.273937 51.6391 0.621625V63.0476C51.6391 63.3952 51.9168 63.6692 52.2692 63.6692H63.4387C63.791 63.6692 64.0687 63.3952 64.0687 63.0476V35.6644C64.0687 30.3754 68.1798 26.319 73.7219 26.319C79.2639 26.319 83.279 30.2911 83.279 35.6644V63.0476C83.279 63.3952 83.5566 63.6692 83.909 63.6692H95.0785C95.4309 63.6692 95.7085 63.3952 95.7085 63.0476V35.6644C95.7085 24.1591 88.0628 16.0464 77.3525 16.0464V16.0358Z" fill="white"></path><path d="M118.389 14.2552C112.324 14.2552 106.622 16.0779 102.542 18.7224C102.265 18.9016 102.169 19.2703 102.34 19.5548L107.262 27.8466C107.444 28.1416 107.828 28.247 108.127 28.0679C111.224 26.2241 114.769 25.2653 118.389 25.2864C128.138 25.2864 135.303 32.0716 135.303 41.0377C135.303 48.6763 129.569 54.3342 122.297 54.3342C116.371 54.3342 112.26 50.9311 112.26 46.1266C112.26 43.3767 113.445 41.122 116.531 39.5311C116.851 39.3625 116.969 38.9727 116.777 38.6671L112.132 30.9126C111.982 30.6598 111.662 30.5439 111.373 30.6492C105.148 32.925 100.78 38.4037 100.78 45.7579C100.78 56.8839 109.761 65.1863 122.287 65.1863C136.916 65.1863 147.434 55.1876 147.434 40.8481C147.434 25.476 135.197 14.2446 118.368 14.2446L118.389 14.2552Z" fill="white"></path><path d="M180.098 15.9515C174.449 15.9515 169.409 18.006 165.725 21.6304C165.522 21.8306 165.191 21.6831 165.191 21.4092V17.0473C165.191 16.6996 164.914 16.4256 164.561 16.4256H153.68C153.328 16.4256 153.05 16.6996 153.05 17.0473V79.3784C153.05 79.7261 153.328 80 153.68 80H164.849C165.202 80 165.48 79.7261 165.48 79.3784V58.9385C165.48 58.6645 165.811 58.5276 166.013 58.7067C169.687 62.0782 174.545 64.0485 180.109 64.0485C193.211 64.0485 203.43 53.5862 203.43 39.9947C203.43 26.4032 193.2 15.941 180.109 15.941L180.098 15.9515ZM177.995 53.4914C170.541 53.4914 164.892 47.6439 164.892 39.9104C164.892 32.177 170.53 26.3295 177.995 26.3295C185.459 26.3295 191.086 32.0822 191.086 39.9104C191.086 47.7387 185.533 53.4914 177.984 53.4914H177.995Z" fill="white"></path></symbol></defs></svg>
              </div>
            </div>
            <div data-testid="upstream-button" class="shopify-payment-button__button shopify-payment-button__button--branded BUz42FHpSPncCPJ4Pr_f">
              <div class="shopify-cleanslate">
                <div role="button" tabindex="0" class="kqsiVA9Jf8LJAbxw8Bau h7OYsWHrW5495r9beh2n jjzYeefyWpPZLH9pIgyw DnvZqPMEvBFbBre5UuP9 size--large" data-testid="ShopifyPay-button"><span class="Xrk_DudB6JJ3t2Kh2_cU">Buy now with ShopPay</span><span aria-hidden="true">Buy with </span><span class="ElVMgDjOgshGFMIvg3se"><svg preserveAspectRatio="xMidYMid" class="qZgSr5RiiBCTAMfQYsty" style="height: 20px; width: 85px;"><use xlink:href="#shopify-svg__payments-shop-pay"></use></svg></span><span aria-hidden="true"></span></div>
              </div>
            </div>
            <button class="shopify-payment-button__more-options BUz42FHpSPncCPJ4Pr_f" type="button" data-testid="sheet-open-button">More Quick Pay Options</button>
          </div>
        </div>
      </div>
    </div>
  `;
  let shopPayPseudo = undefined;
  let morePayPseudo = undefined;
  let shopPayPseudoDesktop = undefined;
  let morePayPseudoDesktop = undefined;

  let realPayContainer = undefined;
  let shopPayReal = undefined;
  let morePayReal = undefined;

  // Defaults
  let shopPayActiveClass = "LVeInvZ5HcNOW1Zsn7NH";
  let moreOptionsActiveAttribute = "aria-disabled";
  let moreOptionsActiveValue = "true";

  // Add to cart btn
  let addToCartBtn = document.querySelector(".product-cta-sticky-menu__add-to-cart-btn");
  let addToCartBtnDesktop = document.querySelector(".product-variant-select__add-to-cart-btn");

  // Errors
  let errorMsg = document.querySelector(".product-cta-sticky-menu__error-msg");
  let errorMsgDesktop = document.querySelector(".product-variant-select__error-msg");

  // Pseudo Loading Shop Pay Btn
  let pseudoLoadingShopPayBtn = document.querySelector(".pseudo-loading-shop-btn");

  // Timeouts
  let timeouts = {
    initQuickPay: undefined,
    endQuickPay: undefined,
    afterFound: undefined,
  };

  // Search for and init quick pay. If not found, retry
  function initQuickPay() {
    // Real
    realPayContainer = document.querySelector(".quick-checkout-buttons");
    shopPayReal = document.querySelector(".quick-checkout-buttons .shopify-payment-button > div > div > div [role='button'][data-testid='ShopifyPay-button']");
    morePayReal = document.querySelector(".quick-checkout-buttons .shopify-payment-button > div > div > div .shopify-payment-button__more-options");

    // Check real
    if (!shopPayReal && !morePayReal) {
      // console.log("Shop pay and more pay not found");
      timeouts.initQuickPay = setTimeout(initQuickPay, 100);

      return;
    }

    // console.log("Shop pay and more pay found");

    // Clear
    if (timeouts.endQuickPay) {
      clearTimeout(timeouts.endQuickPay);
    }

    // Check if product add button is hidden -- if it is, do not show quick pay buttons
    if (document.querySelector(".product-variant-select__add-to-cart-btn.sk-large.sk-hidden")) {
      return;
    }

    // Timeout to avoid shopify's event listeners
    timeouts.afterFound = setTimeout(addPseudo, 1000);
  }

  // Ends search for quick pay
  function endQuickPay() {
    if (timeouts.initQuickPay) {
      clearTimeout(timeouts.initQuickPay);
    }
  }

  // Adds pseudo quick pay
  function addPseudo() {
    // Get time state
    const isTimeProduct = document.querySelector(".product-main-content").getAttribute("data-is-time") === "true" ? true : false;

    // Create Pseudo
    let pseudoPayContainer = document.createElement("div");
    pseudoPayContainer.classList.add("pseudo-quick-checkout-buttons");
    pseudoPayContainer.innerHTML = pseudoPayHtml;

    // Create desktop
    let pseudoPayContainerDesktop = document.createElement("div");
    pseudoPayContainerDesktop.classList.add("pseudo-quick-checkout-buttons");
    pseudoPayContainerDesktop.classList.add("sk-large");
    pseudoPayContainerDesktop.innerHTML = pseudoPayHtml;

    // Create sold out text
    let pseudoPayMoreSoldout = document.createElement("p");
    pseudoPayMoreSoldout.classList.add("pseudo-pay-more-sold-out");
    pseudoPayMoreSoldout.innerText = "Sold out. Sign up for a Back in Stock alert.";

    // if (isTimeProduct) {
    //   pseudoPayMoreSoldout.innerText = "Sold out. Please try again later!";
    // }

    // Get add to cart button
    let addToCartBtn = document.querySelector(".product-cta-sticky-menu__add-to-cart-btn");

    // Get variant select
    let variantSelector = document.querySelector(".product-variant-select form");

    // Add element
    realPayContainer.parentElement.insertBefore(pseudoPayContainer, addToCartBtn);
    variantSelector.insertBefore(pseudoPayContainerDesktop, errorMsgDesktop);

    // Hide pseudo loading button
    pseudoLoadingShopPayBtn.classList.add("sk-hidden");

    // Get buttons
    shopPayPseudo = document.querySelector(".product-cta-sticky-menu .pseudo-quick-checkout-buttons .shopify-payment-button > div > div > div [role='button'][data-testid='ShopifyPay-button']");
    morePayPseudo = document.querySelector(".product-cta-sticky-menu .pseudo-quick-checkout-buttons .shopify-payment-button > div > div > div .shopify-payment-button__more-options");
    shopPayPseudoDesktop = document.querySelector(".product-variant-select .pseudo-quick-checkout-buttons .shopify-payment-button > div > div > div [role='button'][data-testid='ShopifyPay-button']");
    morePayPseudoDesktop = document.querySelector(".product-variant-select .pseudo-quick-checkout-buttons .shopify-payment-button > div > div > div .shopify-payment-button__more-options");

    // Move more pay after add to cart button
    morePayPseudo.remove();
    realPayContainer.parentElement.appendChild(morePayPseudo);

    // Add soldout text
    realPayContainer.parentElement.appendChild(pseudoPayMoreSoldout);

    // Add event listeners
    shopPayPseudo.addEventListener("click", processQuickPay);
    morePayPseudo.addEventListener("click", processQuickPay);
    shopPayPseudoDesktop.addEventListener("click", processQuickPay);
    morePayPseudoDesktop.addEventListener("click", processQuickPay);

    // Hide if not available
    if (addToCartBtn.classList.contains("product-cta-sticky-menu__add-to-cart-btn--sold-out")) {
      pseudoPayContainer.classList.add("disabled");
      morePayPseudo.classList.add("disabled");
      pseudoPayContainerDesktop.classList.add("disabled");
      morePayPseudoDesktop.classList.add("disabled");
    }

    // Disable if is bundle
    if (document.querySelector(".product-main-content").getAttribute("data-product-bundle") === "true") {
      pseudoPayContainer.classList.add("disabled");
      morePayPseudo.classList.add("disabled");
      pseudoPayContainerDesktop.classList.add("disabled");
      morePayPseudoDesktop.classList.add("disabled");
    }
  }

  // Processes quick pay click
  function processQuickPay(e = undefined) {
    if (e) e.preventDefault();

    let btn = e.currentTarget;

    // Button type (for what active type to use -- class or attribute)
    let type = "shop";

    if (btn.classList.contains("shopify-payment-button__more-options")) {
      type = "more";
    }

    // Set to active
    shopPayPseudo.classList.add(shopPayActiveClass);
    morePayPseudo.setAttribute(moreOptionsActiveAttribute, moreOptionsActiveValue);
    shopPayPseudoDesktop.classList.add(shopPayActiveClass);
    morePayPseudoDesktop.setAttribute(moreOptionsActiveAttribute, moreOptionsActiveValue);

    // Show loading
    addToCartBtn.classList.add("product-cta-sticky-menu__add-to-cart-btn--adding");
    addToCartBtnDesktop.classList.add("product-variant-select__add-to-cart-btn--adding");

    // Cart
    cartCount = parseInt(document.querySelector(".menu-bar .cart .item-count").innerText);

    // If cart is > 0, add current product to cart and proceed with checkout
    // If cart is 0, proceed with real button
    if (cartCount > 0) {
      // Get id and quantity
      let variantSelect = document.querySelector("#variant-main-select");
      let index = 0;

      if (variantSelect.selectedIndex > 0) {
        index = variantSelect.selectedIndex;
      }

      let selectedVariantId = parseInt(variantSelect[index].value);
      let selectedQuantity = 1;

      // Add
      Global.Cart.add({id: selectedVariantId, quantity: selectedQuantity})
      .then(res => {
        // Checkout
        window.location.href = "/checkout";
      })
      .catch(res => {
        console.warn("Err: ", res);

        // End Loading
        addToCartBtn.classList.remove("product-cta-sticky-menu__add-to-cart-btn--adding");
        addToCartBtnDesktop.classList.remove("product-variant-select__add-to-cart-btn--adding");

        shopPayPseudo.classList.remove(shopPayActiveClass);
        morePayPseudo.removeAttribute(moreOptionsActiveAttribute);
        shopPayPseudoDesktop.classList.remove(shopPayActiveClass);
        morePayPseudoDesktop.removeAttribute(moreOptionsActiveAttribute);

        if (res.description.includes("You can't add more") &&
            res.description.includes("to the cart")) {
          errorMsg.classList.remove("sk-hidden");
          errorMsg.innerText = "Not enough inventory. Try again with a lower quantity.";
          errorMsgDesktop.classList.remove("sk-hidden");
          errorMsgDesktop.innerText = "Not enough inventory. Try again with a lower quantity.";
        } else if (res.description.includes("All") &&
            res.description.includes("are in your cart")) {
          errorMsg.classList.remove("sk-hidden");
          errorMsg.innerText = "All remaining inventory is in the cart already.";
          errorMsgDesktop.classList.remove("sk-hidden");
          errorMsgDesktop.innerText = "All remaining inventory is in the cart already.";
        } else if (res.status == 422 && res.message.includes("Item limit reached")) {
          errorMsg.classList.remove("sk-hidden");
          errorMsg.innerText = res.message;
          errorMsgDesktop.classList.remove("sk-hidden");
          errorMsgDesktop.innerText = res.message;
        } else {
          errorMsg.classList.remove("sk-hidden");
          errorMsg.innerText = "An error occurred. Please try again soon.";
          errorMsgDesktop.classList.remove("sk-hidden");
          errorMsgDesktop.innerText = "An error occurred. Please try again soon.";
        }
      });
    } else {
      if (type == "shop") {
        shopPayReal.click();
      } else {
        morePayReal.click();
      }
    }
  }

  function init() {
    // End search after set duration
    timeouts.endQuickPay = setTimeout(endQuickPay, 20000);

    // Init
    initQuickPay();
  }

  return Object.freeze({init});
})();

QuickPay.init();

/* Yotpo Review Modification */
let ModifyYotpoReviews = () => {
  // Interval/Timeouts
  let yotpoReviewTabInterval = undefined;
  let yotpoReviewTabTimeout = undefined;

  // Tabs
  let reviewTab = undefined;
  let qnaTab = undefined;

  // Reviews Tab Click Event
  function reviewTabClick(e = undefined) {
    if (!e) return;

    reviewTab.classList.add("selected");
    qnaTab.classList.remove("selected");

    let reviewView = document.querySelector(".yotpo-main-layout.yotpo-main-reviews-widget");
    let qnaView = document.querySelector("#yotpo-app > div > div.yotpo-base-layout > div.yotpo-widget-instance");

    reviewView.style = "";
    qnaView.style = "display: none;";
  }

  // Q&A Tab Click Event
  function qnaTabClick(e = undefined) {
    if (!e) return;

    qnaTab.classList.add("selected");
    reviewTab.classList.remove("selected");

    let qnaView = document.querySelector("#yotpo-app > div > div.yotpo-base-layout > div.yotpo-widget-instance");
    let reviewView = document.querySelector(".yotpo-main-layout.yotpo-main-reviews-widget");

    qnaView.style = "";
    reviewView.style = "display: none;";
  }

  // Runs on page start
  function init() {
    // Start search for yotpo review tabs
    yotpoReviewTabInterval = setInterval(() => {
      // Query for all yotpo tabs
      let yotpoTabs = Array.from(document.querySelectorAll(".ugc-storefront-widgets-tabs-container__tab"));

      if (yotpoTabs.length > 0) {
        clearTimeout(yotpoReviewTabTimeout);
        clearInterval(yotpoReviewTabInterval);

        // Get template tabs
        reviewTab = yotpoTabs[0];
        qnaTab = yotpoTabs[1];

        // Remove template tabs
        reviewTab.remove();
        qnaTab.remove();

        // Get product name
        let productName = document.querySelector(".product-details__primary-info h1").innerText;

        // Create new review tab
        let newReviewTab = document.createElement("h2");
        newReviewTab.classList.add("ugc-storefront-widgets-tabs-container__tab", "selected");
        newReviewTab.innerText = `${productName} Reviews`;

        // Create new qna tab
        let newQnaTab = document.createElement("div");
        newQnaTab.classList.add("ugc-storefront-widgets-tabs-container__tab");
        newQnaTab.innerText = "Q&A";

        // Add tabs to tab container
        let tabsContainer = document.querySelector(".ugc-storefront-widgets-tabs-container.yotpo-main-widget-tabs");

        tabsContainer.appendChild(newReviewTab);
        tabsContainer.appendChild(newQnaTab);

        reviewTab = newReviewTab;
        qnaTab = newQnaTab;

        // Add events to tabs
        newReviewTab.addEventListener("click", reviewTabClick);
        newQnaTab.addEventListener("click", qnaTabClick);
      }
    }, 500);

    // End search if not found
    yotpoReviewTabTimeout = setTimeout(() => {
      clearInterval(yotpoReviewTabInterval);
    }, 15000);
  }

  init();

  return Object.freeze({init});
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    ModifyYotpoReviews = ModifyYotpoReviews();
  });
} else {
  ModifyYotpoReviews = ModifyYotpoReviews();
}

/* Time Button Modification */
let ModifyTimeButton = () => {
  // Interval/Timeouts
  let searchInterval = undefined;
  let searchTimeout = undefined;

  // Runs on page start
  function init() {
    // Start search for yotpo review tabs
    searchInterval = setInterval(() => {
      // Query for time button
      let timeButtons = Array.from(document.querySelectorAll(".servicify-select-a-time-button"));

      if (timeButtons.length > 0) {
        clearTimeout(searchTimeout);
        clearInterval(searchInterval);

        // Remove desktop only class
        timeButtons.forEach(btn => btn.classList.remove("sk-large", "sk-hidden"));
      }
    }, 1000);

    // End search if not found
    searchTimeout = setTimeout(() => {
      clearInterval(searchInterval);
    }, 10000);
  }

  init();

  return Object.freeze({init});
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    ModifyTimeButton = ModifyTimeButton();
  });
} else {
  ModifyTimeButton = ModifyTimeButton();
}
